import React from 'react'
import { SourcingDetailSupplierFormStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  Section,
  SelectBox,
  Input,
  InputUploadExcel,
  Checkbox,
  InputTextarea,
  Table,
  Text,
  Paginate,
  AttachedFile,
  Loading,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, toastFail, toastActive, STRING, yup } from '../../helpers'
import { toast } from 'react-toastify'
import { checkFileType } from '../../helpers/functions/checkFileType'
import { Formik, Form, FieldArray } from 'formik'
import {
  eventNewController,
  mySupplierCompanyController,
} from '../../apiService'
import {
  dateMonDayYearTime,
  dateMonDayYearTimeFull,
  formatNumberWithCommaN2Decimal,
  formatNumberWithCommaN4Decimal,
} from '../../helpers/functions/format'
import FileDownload from 'js-file-download'
import {
  numberRemoveCommas,
  numberDecimalRemoveCommas,
} from '../../helpers/number/commas'
import Numeral from 'numeral'
import NumberFormat from 'react-number-format'
import { localStorageService, pageData } from '../../helpers/functions'
import Moment from 'moment'
import { filter, map } from 'lodash'
import auctionService from '../../apiService/services/auctionService'
import { store } from '../../store'
import moment from 'moment/moment'
import ModalHistoryOfSupplier from '../SourcingCompareEventContainer/element/ModalHistoryOfSupplier'
import { controller } from '../../middleware'
export class SourcingDetailSupplierFormContainer extends React.Component {
  _clickAccept = 0
  _clickAcceptRejAll = 0
  _clickAcceptRejItem = 0
  constructor(props) {
    super(props)
    this.state = {
      unit_price: 0,
      pageLoading: false,
      options: [{ value: 'UOM', label: 'UOM' }],
      activeStep: 0,
      modals: [
        { name: 'buyer-info', isOpen: false },
        { name: 'reject-item', isOpen: false },
        { name: 'terms-conditions', isOpen: false },
        { name: 'warning', isOpen: false },
        { name: 'confirm', isOpen: false },
        { name: 'reject-all', isOpen: false },
        { name: 'confirm-all', isOpen: false },
        { name: 'confirm-response', isOpen: false },
        { name: 'modals-history-of-supplier', isOpen: false },
      ],
      eventType: '',
      suppliersEventData: [],
      sourcingID: '',
      rfqItem: [],
      getRFQItem: {},
      getAuctionItem: {},
      agreeConditions: false,
      selectedFile: [],
      isQuote: false,
      is_reject: '0',
      isRejectIndex: '',
      reasonStatus: [],
      sumGrandTotal: 0,
      isErrReason: false,
      isErrReasonAll: false,
      isErrOther: false,
      isLoading: false,
      clicks: 0,
      defaultSelectedRejAll: {
        value: 0,
        label: 'Select',
        isDisabled: true,
      },
      defaultSelectedRejItem: {
        value: 0,
        label: 'Select',
        isDisabled: true,
      },
      loadingFileInternal: false,
      loadingFileInternalTable: [],
      uploadFail: false,
      dateWithin24: false,
      bidHistoryOfSupplier: [],

      // Paginate
      searchPage: 1,
      activePage: 1,
      limit: 1000,
      total_record: 0,
      offset: 0,
      priceRFQItemHistory: [],
      acceptRFQItem: [],
      arrayUnitPrice: [],
      loadingDownloadFile: [],
    }
    this.renderSourcingDetailFormSupplier = this.renderSourcingDetailFormSupplier.bind(
      this
    )
  }

  componentDidMount = () => {
    localStorageService.clearSourcingDetail()
    // this.getEventSupplier()
    this.checkToken()
  }
  componentWillUnmount = () => {
    this.setState({ isLoading: false })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.modals !== this.state.modals) {
      if (this.state.modals) {
        this.state.modals.map((value, index) => {
          if (value.name === 'reject-all' && value.isOpen === true) {
            this._clickAcceptRejAll = 0
            this._clickAcceptRejItem = 0
            const selected = {
              value: 0,
              label: 'Select',
              isDisabled: true,
            }
            this.setState({ defaultSelectedRejAll: selected })
          } else if (value.name === 'reject-item' && value.isOpen === true) {
            this._clickAcceptRejAll = 0
            this._clickAcceptRejItem = 0
            const selected = {
              value: 0,
              label: 'Select',
              isDisabled: true,
            }
            this.setState({ defaultSelectedRejItem: selected })
          }
        })
      }
    }
  }
  goBack = () => {
    this.props.history.push(ROUTE_PATH.SOURCING_SUPPLIER.LINK)
  }

  checkToken = async () => {
    const tokens = new URLSearchParams(this.props.location.search).get('token')
    // console.log('tokens', tokens)
    if (tokens) {
      try {
        const resToken = await mySupplierCompanyController().getVerifyToken(
          tokens
        )
        // console.log('resToken', resToken)
        if (resToken && resToken.is_verify) {
          localStorageService.clearSourcingDetail()
          this.getEventSupplier()
        } else {
          toastFail(resToken.message)
          // this.goBack()
          controller().redirectToLogin()
        }
      } catch (e) {
        this.goBack()
      }
    } else {
      localStorageService.clearSourcingDetail()
      this.getEventSupplier()
    }
  }

  getEventSupplier = async () => {
    let id = this.props.match.params ? this.props.match.params.id : ''
    this.setState({ id: id })

    try {
      if (!id) {
        this.goBack()
      }

      {
        const res = await mySupplierCompanyController().getRFQEvent(id)
        if (res) {
          if (res.sourcing_id) {
            let getSupplierIdData
            let getSupplierData
            let getBuyerData
            let getRFQItemData
            let getAuctionItemData
            let getDownloadFileBuyerInfoData
            let getSupplierEventFileData
            let getBidHistoryOfSupplierData

            getBuyerData = await mySupplierCompanyController().getBuyerCompany(
              res.sourcing_id
            )

            this.getReason(res.event_type_id)

            // RFQ
            if (res.event_type_id === 1) {
              getSupplierIdData = await mySupplierCompanyController().getRFQSupplierID(
                res.sourcing_id
              )
              let resSupplierData = await mySupplierCompanyController().getRFQSupplier(
                res.sourcing_id
              )
              if (
                resSupplierData ===
                '57004: unauthorized, supplier was not invited'
              ) {
                this.props.history.push('')
                toastFail('Unauthorized')
              } else {
                getSupplierData = resSupplierData
              }
              let resRFQItemData = await mySupplierCompanyController().getRFQItem(
                res.sourcing_id
              )
              if (
                resRFQItemData !==
                '57004: unauthorized, supplier was not invited'
              ) {
                getRFQItemData = resRFQItemData
              }
              // getDownloadFileBuyerInfoData = await mySupplierCompanyController().getDownloadFileBuyerInfo(
              //   res.sourcing_id
              // )

              if (
                resSupplierEventFileData !==
                '57004: unauthorized, supplier was not invited'
              ) {
                getSupplierEventFileData = resSupplierEventFileData
              }
            }

            // Auction
            if (res.event_type_id === 2) {
              getSupplierIdData = await mySupplierCompanyController().getAuctionSupplierID(
                res.sourcing_id
              )
              let resSupplierData = await mySupplierCompanyController().getAuctionSupplier(
                res.sourcing_id
              )
              if (
                resSupplierData ===
                '57004: unauthorized, supplier was not invited'
              ) {
                this.props.history.push('')
                toastFail('Unauthorized')
              } else {
                getSupplierData = resSupplierData
              }
              let resAuctionItemData = await mySupplierCompanyController().getAuctionItem(
                res.sourcing_id
              )
              if (
                resAuctionItemData !==
                '57004: unauthorized, supplier was not invited'
              ) {
                getAuctionItemData = resAuctionItemData
              }
              // getDownloadFileBuyerInfoData = await mySupplierCompanyController().getDownloadFileBuyerInfoAuction(
              //   res.sourcing_id
              // )
            }

            getDownloadFileBuyerInfoData = await mySupplierCompanyController().getEventFileBuyerInfo(
              res.sourcing_id
            )
            let resSupplierEventFileData = await mySupplierCompanyController().getSupplierEventFile(
              res.sourcing_id
            )

            let item_suppliers = []
            // if (
            //   res.event_type_id === 1 &&
            //   getRFQItemData &&
            //   getRFQItemData.item_suppliers.length > 0
            // ) {
            //   item_suppliers = getRFQItemData.item_suppliers.map(i => ({
            //     description: i.description,
            //     id: i.id,
            //     is_reject: i.is_reject,
            //     name: i.name,
            //     note_to_buyer: i.note_to_buyer,
            //     reject_reason: i.reject_reason,
            //     req_amount: i.req_amount,
            //     rfq_buyer_item_file: i.rfq_buyer_item_file,
            //     rfq_item_id: i.event_item_id,
            //     total_price: i.total_price === '' ? '0.00' : i.total_price,
            //     unit_price: i.is_reject === true ? '0.00' : i.unit_price,
            //     uom: i.uom,
            //     uom_id: i.uom_id,
            //     rfq_supplier_item_file:
            //       i.rfq_supplier_item_file.length > 0
            //         ? i.rfq_supplier_item_file.map(j => ({
            //             id: j.id,
            //             name: j.name,
            //             is_deleted: false,
            //           }))
            //         : [],
            //   }))
            // }

            // console.log('getAuctionItemData', getAuctionItemData)
            if (res.event_type_id === 2) {
              // console.log(getAuctionItemData)
              if (
                getSupplierIdData &&
                getAuctionItemData &&
                getAuctionItemData.item_suppliers.length > 0
              ) {
                item_suppliers = getAuctionItemData.item_suppliers.map(i => ({
                  description: i.description,
                  id: i.id,
                  is_reject: i.is_reject,
                  name: i.name,
                  note_to_buyer: i.note_to_buyer,
                  reject_reason: i.reject_reason,
                  req_amount: i.req_amount,
                  auction_buyer_item_file: i.auction_buyer_item_file,
                  auction_item_id: i.auction_item_id,
                  total_price: i.total_price === '' ? '0.00' : i.total_price,
                  unit_price: i.unit_price === '' ? '0.00' : i.unit_price,
                  uom: i.uom,
                  uom_id: i.uom_id,
                  auction_supplier_item_file: i.auction_supplier_item_file.map(
                    j => ({
                      id: j.id,
                      name: j.name,
                      is_deleted: false,
                    })
                  ),
                }))
                getBidHistoryOfSupplierData = await auctionService.getBiddingHistoryOfSupplierByAuctionId(
                  res.sourcing_id
                )
                if (
                  !getBidHistoryOfSupplierData ||
                  getBidHistoryOfSupplierData.length === 0
                ) {
                  setTimeout(async () => {
                    getBidHistoryOfSupplierData = await auctionService.getBiddingHistoryOfSupplierByAuctionId(
                      res.sourcing_id
                    )
                  }, 1000)
                }
              }
            }

            let supplier_file = []
            // console.log('getSupplierEventFileData', getSupplierEventFileData)
            if (getSupplierEventFileData) {
              supplier_file = getSupplierEventFileData.map(i => ({
                id: i.id,
                name: i.name,
                // status: true,
                is_deleted: false,
              }))
            }
            const then = new Date(
              getSupplierIdData && getSupplierIdData.start_date
            )

            const dayDiff = moment(then).diff(moment(), 'days')
            // console.log('dayDiff', dayDiff)
            if (dayDiff >= 1) {
              this.setState({ dateWithin24: false })
            } else {
              this.setState({ dateWithin24: true })
            }

            if (getRFQItemData || getAuctionItemData) {
              console.log({ getRFQItemData })
              this.setState({
                eventType: res.event_type_id,
                sourcingID: res.sourcing_id,
                event_id: res.id,
                suppliersEventData: getSupplierIdData,
                getBuyerData: getBuyerData,
                getSupplier: getSupplierData,
                // getItemSuppliers: getRFQItemData.item_suppliers,

                // Get items RFQ
                ...(res.event_type_id === 1 && {
                  getRFQItem: {
                    // item_suppliers: [...item_suppliers],
                    note_to_buyer: getRFQItemData.note_to_buyer,
                    cancel_reason: getRFQItemData.cancel_reason,
                    is_cancel: getRFQItemData.is_cancel,
                    rfq_id: getRFQItemData.rfq_id,
                    rfq_supplier_id: getRFQItemData.rfq_supplier_id,
                    rfq_supplier_response_reason:
                      getRFQItemData.rfq_supplier_response_reason,
                    rfq_supplier_response_status:
                      getRFQItemData.rfq_supplier_response_status,
                    rfq_supplier_response_status_id:
                      getRFQItemData.rfq_supplier_response_status_id,
                    supplier_id: getRFQItemData.supplier_id,
                    total_price: getRFQItemData.total_price,
                    rfq_status_id: getRFQItemData.rfq_status_id,
                  },
                }),

                // Get items Auction
                ...(res.event_type_id === 2 &&
                  getAuctionItemData && {
                    getAuctionItem: {
                      item_suppliers: [...item_suppliers],
                      note_to_buyer: getAuctionItemData.note_to_buyer,
                      cancel_reason: getAuctionItemData.cancel_reason,
                      is_cancel: getAuctionItemData.is_cancel,
                      auction_id: getAuctionItemData.auction_id,
                      auction_supplier_id:
                        getAuctionItemData.auction_supplier_id,
                      auction_supplier_response_reason:
                        getAuctionItemData.auction_supplier_response_reason,
                      auction_supplier_response_status:
                        getAuctionItemData.auction_supplier_response_status,
                      auction_supplier_response_status_id:
                        getAuctionItemData.auction_supplier_response_status_id,
                      supplier_id: getAuctionItemData.supplier_id,
                      total_price: getAuctionItemData.total_price,
                      auction_status_id: getAuctionItemData.auction_status_id,
                    },
                    bidHistoryOfSupplier: getBidHistoryOfSupplierData,
                  }),

                // getRFQItem: getRFQItemData,
                getDownloadFileBuyerInfo: getDownloadFileBuyerInfoData,
                getSupplierEventFile: getSupplierEventFileData,
                supplierEventFile: [...supplier_file],
              })
            }
          }

          if (
            res.event_type_id === 1 &&
            (this.state.getRFQItem.rfq_supplier_response_status === '' ||
              this.state.getRFQItem.rfq_supplier_response_status_id === 1)
            // this.state.getRFQItem.rfq_supplier_term_status === 1
          ) {
            this.setState({
              modals: [
                { name: 'buyer-info', isOpen: false },
                { name: 'reject-item', isOpen: false },
                { name: 'terms-conditions', isOpen: true },
                { name: 'warning', isOpen: false },
                { name: 'confirm', isOpen: false },
                { name: 'reject-all', isOpen: false },
                { name: 'confirm-all', isOpen: false },
                { name: 'confirm-response', isOpen: false },
              ],
            })
          }

          if (
            res.event_type_id === 2 &&
            (this.state.getAuctionItem.auction_supplier_response_status ===
              '' ||
              this.state.getAuctionItem.auction_supplier_response_status_id ===
                1)
          ) {
            this.setState({
              modals: [
                { name: 'buyer-info', isOpen: false },
                { name: 'reject-item', isOpen: false },
                { name: 'terms-conditions', isOpen: true },
                { name: 'warning', isOpen: false },
                { name: 'confirm', isOpen: false },
                { name: 'reject-all', isOpen: false },
                { name: 'confirm-all', isOpen: false },
                { name: 'confirm-response', isOpen: false },
              ],
            })
          }

          this.setState({
            suppliersEvent: res,
          })
          if (res.event_type_id === 1) {
            console.log({ res })
            this.getRFQSupplierItemList(res.id, this.state.activePage)
          }
          this.checkModalWarning()
        }
      }
    } catch (error) {
      throw ('fetchSupplerByID fail', error)
    }
  }

  getRFQSupplierItemList = async (id, activePage = '', setFieldValue) => {
    let { getRFQItem, priceRFQItemHistory, acceptRFQItem, limit } = this.state
    let params = {
      page: activePage ? activePage : 1,
      limit: 1000,
    }
    let res = await mySupplierCompanyController().getRFQSupplierItem(id, params)
    if (res) {
      if (res.records) {
        res.records.map(values => {
          if (values.event_supplier_item_files === null) {
            values.event_supplier_item_files = []
          }
        })
        acceptRFQItem = res.records
        let items = res.records
        // fix bug reject all
        if (getRFQItem.rfq_supplier_response_status === 'Rejected') {
          items.map(item => {
            item.is_reject = true
          })
        }
        getRFQItem.item_suppliers = items
      }
      // console.log({ records: res.records, RFQitems: getRFQItem.item_suppliers })

      this.setState({
        getRFQItem,
        acceptRFQItem,
        total_record: res.total_record,
        total_page: res.total_page,
        offset_page: res.offset,
      })
    }
  }

  changePage = async (activePage, setFieldValue) => {
    const { event_id, getRFQItem } = this.state
    this.setState({ activePage: activePage })
    if (getRFQItem.rfq_status_id !== 3) {
      this.getRFQSupplierItemList(event_id, activePage, setFieldValue)
    }
  }

  checkModalWarning() {
    const { suppliersEvent, suppliersEventData, getAuctionItem } = this.state
    const startDate = new Date(
      suppliersEventData && suppliersEventData.start_date
    )
    const dayDiff = moment(startDate).diff(moment(), 'days')
    if (
      suppliersEvent &&
      suppliersEvent.event_type_id === 2 &&
      suppliersEventData.auction_status_id === 2 &&
      dayDiff >= 1 &&
      getAuctionItem.auction_supplier_response_status_id === 2
    ) {
      this.toggleModal('warning')
    }
  }

  getReason = async eventType => {
    let reasonStatus
    if (eventType === 1) {
      reasonStatus = await mySupplierCompanyController().getReason()
    }
    if (eventType === 2) {
      reasonStatus = await mySupplierCompanyController().getReasonAuction()
    }
    if (reasonStatus) {
      let option = [
        // {
        //   value: 0,
        //   label: 'Select',
        //   isDisabled: true,
        // },
      ]
      reasonStatus.map(e => {
        const data = { value: e.ID, label: e.name }
        option.push(data)
      })
      this.setState({ reasonStatus: option })
    } else {
      toastFail('error')
    }
  }

  downloadAttachment = params => {
    // if (this.state.eventType === 1) {
    //   return mySupplierCompanyController()
    //     .downloadFileBuyerInfo(params.id)
    //     .then(res => {
    //       this.deleteLoadingDownloadFile(params)
    //       FileDownload(res.data, params.name)
    //     })
    // }
    // if (this.state.eventType === 2) {
    //   return mySupplierCompanyController()
    //     .downloadFileBuyerInfoAuction(params.id)
    //     .then(res => {
    //       this.deleteLoadingDownloadFile(params)
    //       FileDownload(res.data, params.name)
    //     })
    // }
    return mySupplierCompanyController()
      .downloadFileBuyerInfoEvent(params.id)
      .then(res => {
        this.deleteLoadingDownloadFile(params)
        FileDownload(res.data, params.name)
      })
  }

  downloadAttachmentItem = params => {
    return mySupplierCompanyController()
      .downloadFileItem(params.id)
      .then(res => {
        this.deleteLoadingDownloadFile(params)
        FileDownload(res.data, params.name)
      })
  }

  downloadSupplierAttachmentItem = params => {
    return mySupplierCompanyController()
      .downloadSupplierFileItem(params.id)
      .then(res => {
        setTimeout(() => {
          this.deleteLoadingDownloadFile(params)
          FileDownload(res.data, params.name)
        }, 500)
      })
  }

  downloadSupplierEventFile = params => {
    return mySupplierCompanyController()
      .downloadSupplierEventFile(params.id)
      .then(res => {
        setTimeout(() => {
          this.deleteLoadingDownloadFile(params)
          FileDownload(res.data, params.name)
        }, 500)
      })
  }

  // On file select (from the pop up)
  readUploadFile = async event => {
    // Update the state
    const { getRFQItem, suppliersEventData } = this.state
    this.setState({ uploadFail: false, isLoading: true })
    const value = event.target.files[0]
    const res = value.name.substr(value.name.lastIndexOf('.')) === '.xlsx'
    if (res) {
      let formData = new FormData()
      formData.append('file', value)
      formData.append('rfq_supplier_id', getRFQItem.rfq_supplier_id)
      const resFiles = await mySupplierCompanyController().uploadProductItem(
        formData
      )
      let errmsg
      if (resFiles.includes('53009: ')) {
        errmsg = resFiles.split('53009: ')
        toastFail(errmsg[1])
        this.setState({ isLoading: false, uploadFail: true })
      } else if (resFiles.includes('53010')) {
        errmsg = resFiles.split('53010: ')
        toastFail(errmsg[1])
        this.setState({ isLoading: false, uploadFail: true })
      } else if (resFiles.includes('53011')) {
        errmsg = resFiles.split('53011: ')
        toastFail(errmsg[1])
        this.setState({ isLoading: false, uploadFail: true })
      } else if (resFiles.includes('53012')) {
        errmsg = resFiles.split('53012: ')
        toastFail(errmsg[1])
        this.setState({ isLoading: false, uploadFail: true })
      } else if (resFiles.length !== 0) {
        // console.log({ resFiles })
        const { item_suppliers } = getRFQItem
        const item_suppliers_list = []
        let grand_total_price = 0
        map(item_suppliers, async item => {
          // console.log({ item })
          const data = filter(resFiles, r => {
            return r.id === item.id
          })
          if (data.length !== 0) {
            item.note_to_buyer = data[0].note_to_buyer
            item.total_price =
              data[0].total_price === ''
                ? '0.00'
                : Numeral(data[0].total_price).format('0.0000')
            // item.unit_price =
            //   data[0].is_reject === true
            //     ? '0.00'
            //     : Numeral(data[0].unit_price).format('0.0000')
            // item.is_reject = data[0].is_reject

            /* set unit price is upload & reject is default */
            item.unit_price =
              data[0].unit_price === ''
                ? '0.00'
                : Numeral(data[0].unit_price).format('0.0000')
            item.is_reject = false
          }
          item_suppliers_list.push(item)
          grand_total_price += parseFloat(item.total_price)
        })
        this.setState({
          selectedFile: null,
          isLoading: false,
          getRFQItem: {
            ...getRFQItem,
            item_suppliers: item_suppliers_list,
            total_price: Numeral(grand_total_price).format('0.00'),
            fake_id_upload: Math.random().toString(36).substring(2, 8),
          },
        })
        toastActive('Upload successfully')
        this.forceUpdate()
      }
    } else {
      this.setState({ isLoading: false, uploadFail: true })
      toastFail('Incorrect file format')
    }
  }

  onClickTemplateLink = e => {
    const { getRFQItem, suppliersEventData } = this.state
    if (e.detail === 1) {
      return this._downloadTemplateLink(
        getRFQItem.rfq_supplier_id,
        suppliersEventData.currency
      )
    }
  }

  _downloadTemplateLink = (rfq_supplier_id, currency_name) => {
    this.setState({ isLoading: true })
    return mySupplierCompanyController()
      .downloadProductItem(rfq_supplier_id, currency_name)
      .then(res => {
        this.setState({ isLoading: false })
        FileDownload(
          res.data,
          'Item_Supplier_Template_' + Moment().format('DDMMyyyy_hhmm') + '.xlsx'
        )
      })
      .catch(err => {
        this.setState({ isLoading: false })
        throw err
      })
  }

  setInputArray = (formikSetvalue, event, index, values = {}) => {
    let { getRFQItem } = this.state
    const { target } = event
    const checkLength =
      target.value.toString().split('.')[1] &&
      target.value.toString().split('.')[1].length
    if (!checkLength || checkLength <= 4) {
      if (target.value < 0 || target.value === '-' || target.value === '.') {
        formikSetvalue(`item_suppliers[${index}].unit_price`, 0)
      } else if (target.value === '') {
        formikSetvalue(`item_suppliers[${index}].unit_price`, '')
        formikSetvalue(
          `item_suppliers[${index}].total_price`,
          Numeral(0).format('0.0000')
        )
      } else {
        formikSetvalue(`item_suppliers[${index}].unit_price`, target.value)

        const totalPrice =
          values.item_suppliers[index].req_amount *
          Numeral(target.value).format('0.0000')

        formikSetvalue(
          `item_suppliers[${index}].total_price`,
          parseFloat(totalPrice)
        )
        // getRFQItem.item_suppliers[index].unit_price = target.value
        // getRFQItem.item_suppliers[index].total_price = parseFloat(totalPrice)
      }
      // this.setState({ getRFQItem })
    }
  }

  setNoteArray = (formikSetvalue, event, index) => {
    const { target } = event
    formikSetvalue(`item_suppliers[${index}].note_to_buyer`, target.value)
  }

  toggleModal = (evt, id, name) => {
    this.setState(
      prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === evt ? !modal.isOpen : false,
          Idlist: id,
        })),
      })
      // () => {
      //   console.log('this.state.modals', this.state.modals)
      // }
    )
    // document.body.classList.add('modal-open')
  }

  setInputArrayUploadFile = async (e, i, values, setFieldValue) => {
    // console.log('values file', values)
    let { getRFQItem } = this.state
    getRFQItem.item_suppliers[i].event_supplier_item_files =
      values.item_suppliers[i].event_supplier_item_files

    // let index = this.state.loadingFileInternalTable.findIndex(x => x.id === i)
    // this.state.loadingFileInternalTable.splice(index, 1)
    this.forceUpdate()
    this.setState({ getRFQItem })
  }

  setUploadEventFile = async (file, i, values) => {
    let { getSupplierEventFile, supplierEventFile } = this.state
    // let file = e.target.files[0]
    // let supplierEventFiles = file.name
    this.setState({ loadingFileInternal: true })
    const params = { file, name: file.name }
    // console.log({ params })
    if (params) {
      // const supplierEventFiles = await mySupplierCompanyController().rfqSupplierEventFile(
      //   params
      // )
      const supplierEventFiles = await eventNewController().rfqSupplierEventFile(
        params
      )
      // console.log({ supplierEventFiles })
      this.setState({ supplierEventFiles })

      if (supplierEventFiles === '4010: File contains code') {
        toast.error('Wrong file format.')
        this.setState({ loadingFileInternal: false })
      } else if (supplierEventFiles && supplierEventFiles.id) {
        getSupplierEventFile.push({
          name: supplierEventFiles.name,
          id: supplierEventFiles.id,
          is_deleted: false,
        })
        supplierEventFile.push({
          name: supplierEventFiles.name,
          id: supplierEventFiles.id,
          // status: true,
          is_deleted: false,
        })
        this.forceUpdate()
        this.setState({
          getSupplierEventFile,
          supplierEventFile,
          loadingFileInternal: false,
        })
      }
    } else {
      toastFail('Failed to upload file, please try again.')
    }
  }

  deleteArrayFile = (formikSetvalue, value, event, i, indexfile) => {
    this.setState(dataState => {
      let { getRFQItem } = dataState
      getRFQItem = value
      let index = getRFQItem.item_suppliers[
        i
      ].event_supplier_item_files.findIndex(e => e.id === indexfile)
      getRFQItem.item_suppliers[i].event_supplier_item_files[
        index
      ].is_deleted = true
      // getRFQItem.item_suppliers[i].rfq_supplier_item_file[
      //   index
      // ].is_delete = true
      // getRFQItem.item_suppliers[i].rfq_supplier_item_file[index].status = false
      // console.log('remove', getRFQItem.item_suppliers[i].rfq_supplier_item_file)

      const resGetRFQItem = { ...getRFQItem, getRFQItem }
      return { getRFQItem: resGetRFQItem }
    })
  }

  deleteArrayEventFile = (event, i) => {
    let { supplierEventFile } = this.state

    const deleteFile = event

    deleteFile.status = false
    supplierEventFile[i].status = false

    const newEventFileDelete = supplierEventFile
    this.setState({ newEventFileDelete, supplierEventFile })
  }

  setLoadingDownloadFile = file => {
    this.state.loadingDownloadFile.push({ id: file.id })
    this.setState({
      loadingDownloadFile: this.state.loadingDownloadFile,
    })
  }

  deleteLoadingDownloadFile = file => {
    let index = this.state.loadingDownloadFile.findIndex(x => x.id === file.id)
    this.state.loadingDownloadFile.splice(index, 1)
    this.setState({
      loadingDownloadFile: this.state.loadingDownloadFile,
    })
  }

  onAgreeConditions = () => {
    const agreeConditions = !this.state.agreeConditions
    this.setState({
      agreeConditions,
    })
  }

  onClickOkRejectItem = (rejectItem, sumItemSuppliers) => {
    let { getRFQItem, defaultSelectedRejItem } = this.state
    if (
      this.reasonStatus === undefined ||
      this.reasonStatus === '' ||
      defaultSelectedRejItem.label === 'Select'
    ) {
      this.setState({ isErrReason: true })
      this._clickAcceptRejItem = 0
    } else if (rejectItem.reject_reason === '') {
      this.setState({ isErrOther: true })
      this._clickAcceptRejItem = 0
    } else if (sumItemSuppliers && rejectItem) {
      rejectItem.unit_price = 0
      rejectItem.is_reject = true
      rejectItem.total_price = 0
      if (
        rejectItem.event_supplier_item_files &&
        rejectItem.event_supplier_item_files.length > 0
      ) {
        rejectItem.event_supplier_item_files.map(val => {
          return (val.is_delete = true)
        })
      }

      this.setState({
        // sumGrandTotal,
        isErrReason: false,
        isErrOther: false,
        rejectItem: '',
        isRejectIndex: '',
      })
      this.toggleModal('reject-item'),
        document.body.classList.remove('modal-open')
    }
  }

  acceptAgreeConditions = async () => {
    const { event_id } = this.state
    try {
      let res = mySupplierCompanyController().acceptTermCondition(event_id)
      if (res) {
        document.body.classList.remove('modal-open')
        this.toggleModal('terms-conditions')
        this.getEventSupplier()
        // if (this.state.eventType === 2) {
        //   this.checkModalWarning()
        // }
      }
    } catch (error) {
      throw ('update suppiler fail', error)
    }
  }
  onClickConfirmResponse = formData => {
    this.toggleModal('confirm-response'),
      document.body.classList.add('modal-open')
    this.setState({
      formData,
    })
  }

  onClickSaveData = async formData => {
    console.log({ formData })
    try {
      if (formData !== '' && !this.state.isLoading) {
        // const totalPrice = formData.item_suppliers.reduce((a, b) =>
        //   parseFloat(a.total_price + b.total_price)
        // )
        const { eventType, priceRFQItemHistory, getRFQItem } = this.state
        const totalPrice = formData.item_suppliers.reduce((sum, number) => {
          return parseFloat(sum) + parseFloat(number.total_price)
        }, 0)
        this.setState({ isLoading: true })
        let params
        // console.log({ formData, priceRFQItemHistory, getRFQItem })
        if (eventType === 1) {
          params = {
            rfq_supplier_id: formData.rfq_supplier_id,
            total_price: parseFloat(totalPrice).toString(),
            reject_reason: formData.reject_reason,
            rfq_id: formData.rfq_id,
            note_to_buyer: this.state.getRFQItem.note_to_buyer,
            rfq_supplier_file: this.state.supplierEventFile.map(e => {
              return {
                id: e.id,
                name: e.name,
                // status: e.status,
                is_deleted: e.is_deleted,
              }
            }),
            rfq_item_suppliers: formData.item_suppliers.map((val, i) => {
              return {
                id: val.id,
                rfq_item_id: val.event_item_id,
                rfq_supplier_id: formData.rfq_supplier_id,
                unit_price: numberDecimalRemoveCommas(
                  val.unit_price.toString()
                ),
                note_to_buyer: val.note_to_buyer,
                is_reject: val.is_reject === true ? true : false,
                rfq_reject_reason_id: '',
                reject_reason: val.reject_reason,
                total_price: isNaN(val.total_price.toString())
                  ? '0'
                  : parseFloat(val.total_price).toString(),
                // supplier_item_files: [],
                supplier_item_files: this.state.getRFQItem.item_suppliers[i]
                  .event_supplier_item_files,
              }
            }),
          }
        }
        if (eventType === 2) {
          params = {
            auction_supplier_id: formData.auction_supplier_id,
            note_to_buyer: formData.note_to_buyer,
            reject_reason: formData.reject_reason,
            auction_id: formData.auction_id,
            auction_supplier_file: this.state.supplierEventFile.map(e => {
              return {
                id: e.id,
                name: e.name,
                // status: e.status,
                is_deleted: e.is_deleted,
              }
            }),
          }
        }

        let res
        if (eventType === 1) {
          // res = { status: 'success' }
          res = await mySupplierCompanyController().onClickAcceptResponse(
            params
          )
        }
        if (eventType === 2) {
          res = await mySupplierCompanyController().onClickAcceptResponseAuction(
            params
          )
        }
        // console.log('check res-->', res)
        const { data, status } = res
        const funcToastEventIsClosed = message => {
          const funcMessage = () => {
            if (message) {
              return message
            } else {
              return 'Event Is Closed'
            }
          }
          const textToast = funcMessage()
          return toast(textToast, {
            onClose: () => {
              window.location.reload()
            },
            toastId: textToast,
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            type: 'error',
          })
        }
        const funcAccept = () => {
          if (status === 500) {
            if (data) {
              const { result } = data
              if (result === '50100: event is already expired') {
                this.setState({ isLoading: false })
                funcToastEventIsClosed()
              }
            }
          } else if (status === 200) {
            const { result } = data
            if (result.status === 'UpdateSuccess') {
              this.setState({ isLoading: false })
              toastActive(result.message)
              this.getEventSupplier()
              this.props.history.push(ROUTE_PATH.SOURCING_SUPPLIER.LINK)
            } else if (result.status === 'DateExpired') {
              this.setState({ isLoading: false })
              funcToastEventIsClosed()
            } else if (result === '53004: start date before time now') {
              this.setState({ isLoading: false })
              toastFail('Start date before time now')
            } else if (result.status === 'EventCancelled') {
              this.setState({ isLoading: false })
              funcToastEventIsClosed('Event is cancelled')
            } else {
              this.setState({ isLoading: false })
              funcToastEventIsClosed()
            }
          } else {
            this.setState({ isLoading: false })
            funcToastEventIsClosed()
          }
        }
        try {
          funcAccept()
        } catch (error) {
          this.setState({ isLoading: false })
          console.log(error)
        }
      }
    } catch (error) {
      throw ('update suppiler fail', error)
    }
  }

  checkUserHandleItem = (values = {}) => {
    if (values) {
      const { item_suppliers } = values
      if (item_suppliers) {
        return item_suppliers.some(
          item =>
            item.unit_price !== '' ||
            item.note_to_buyer !== '' ||
            item.is_reject === true
        )
      }
    }
  }

  onClickSaveDraft = async values => {
    try {
      if (values !== '' && !this.state.isLoading) {
        this.setState({ isLoading: true })
        // const totalPrice = values.item_suppliers.reduce((a, b) =>
        //   parseFloat(a.total_price + b.total_price)
        // )
        const totalPrice = values.item_suppliers.reduce((sum, number) => {
          return parseFloat(sum) + parseFloat(number.total_price)
        }, 0)
        if (this.checkUserHandleItem(values)) {
          const params = {
            rfq_supplier_id: values.rfq_supplier_id,
            total_price: numberRemoveCommas(totalPrice.toString()),
            reject_reason: values.reject_reason,
            rfq_id: values.rfq_id,
            note_to_buyer: this.state.getRFQItem.note_to_buyer,
            rfq_supplier_file: this.state.supplierEventFile.map(e => {
              return {
                id: e.id,
                name: e.name,
                // status: e.status,
                is_deleted: e.is_deleted,
              }
            }),
            rfq_item_suppliers: values.item_suppliers.map((val, i) => {
              return {
                id: val.id,
                rfq_item_id: val.event_item_id,
                rfq_supplier_id: values.rfq_supplier_id,
                unit_price: numberDecimalRemoveCommas(
                  val.unit_price.toString()
                ),

                note_to_buyer: val.note_to_buyer,
                is_reject: val.is_reject === true ? true : false,
                rfq_reject_reason_id: '',
                reject_reason: val.reject_reason,
                total_price: isNaN(val.total_price)
                  ? '0'
                  : parseFloat(val.total_price).toString(),

                supplier_item_files: this.state.getRFQItem.item_suppliers[i]
                  .event_supplier_item_files,
              }
            }),
          }
          const res = await mySupplierCompanyController().onClickSaveDraft(
            params
          )
          if (res) {
            if (res.status === 'UpdateSuccess') {
              this.setState({ isLoading: false })
              toastActive(res.message)
              this.getEventSupplier()
            } else {
              this.setState({ isLoading: false })
              toastFail(res.message)
            }
          }
        } else {
          this.setState({ isLoading: false })
          toastFail('Please fill in at least one field')
        }
      }
    } catch (error) {
      this.setState({ isLoading: false })
      throw ('update suppiler fail', error)
    }
  }

  onClickReject = () => {
    this.toggleModal('reject-all'), document.body.classList.add('modal-open')
  }

  onClickOkReject = async getItem => {
    const {
      defaultSelectedRejAll,
      eventType,
      getRFQItem,
      getAuctionItem,
    } = this.state
    try {
      if (!this.state.isLoading) {
        this.setState({ isLoading: true })
        if (
          this.reasonStatus === undefined ||
          this.reasonStatus === '' ||
          defaultSelectedRejAll.label === 'Select'
        ) {
          this._clickAcceptRejAll = 0
          this.setState({ isErrReasonAll: true, isLoading: false })
        } else if (getItem.reject_reason === '') {
          this.setState({ isErrOther: true, isLoading: false })
          this._clickAcceptRejAll = 0
        } else if (getItem.reject_reason !== '') {
          this.toggleModal('reject-all')
          document.body.classList.remove('modal-open')

          let params

          if (eventType === 1) {
            params = {
              rfq_supplier_id: getItem.rfq_supplier_id,
              note_to_buyer: getItem.note_to_buyer,
              total_price: '0',
              reject_reason: getItem.reject_reason,
              rfq_id: getItem.rfq_id,
              rfq_supplier_file: this.state.supplierEventFile.map(e => {
                return {
                  id: e.id,
                  name: e.name,
                  // status: e.status,
                  is_deleted: e.is_deleted,
                }
              }),
              rfq_item_suppliers: getItem.item_suppliers.map((val, i) => {
                return {
                  id: val.id,
                  rfq_item_id: val.event_item_id,
                  rfq_supplier_id: val.rfq_supplier_id,
                  unit_price: '0',
                  note_to_buyer: val.note_to_buyer,
                  is_reject: true,
                  rfq_reject_reason_id: '',
                  reject_reason: `${this.state.isRejectIndex}`
                    ? val.reject_reason
                    : '',
                  total_price: '0',
                  supplier_item_files:
                    getRFQItem.item_suppliers[i].event_supplier_item_files,
                }
              }),
            }
          }
          // console.log('getItem', getItem)
          if (eventType === 2) {
            params = {
              auction_supplier_id: getItem.auction_supplier_id,
              note_to_buyer: getItem.note_to_buyer,
              reject_reason: getItem.reject_reason,
              auction_id: getItem.auction_id,
              auction_supplier_file: this.state.supplierEventFile.map(e => {
                return {
                  id: e.id,
                  name: e.name,
                  // status: e.status,
                  is_deleted: e.is_deleted,
                }
              }),
            }
          }
          this.setState({ isRejectIndex: '' })

          // let params = {
          //   rfq_supplier_id: getRFQItem.rfq_supplier_id,
          //   total_price: '0',
          //   reject_reason: getRFQItem.reject_reason,
          //   rfq_item_suppliers: [],
          //   rfq_id: getRFQItem.rfq_id,
          // }

          let res
          if (this.state.eventType === 1) {
            res = await mySupplierCompanyController().onClickRejectTimeOut(
              params
            )
          }
          if (this.state.eventType === 2) {
            res = await mySupplierCompanyController().onClickRejectTimeOutAuction(
              params
            )
          }
          // console.log('res', res)
          const { data, status } = res
          const funcToastEventIsClosed = message => {
            const funcMessage = () => {
              if (message) {
                return message
              } else {
                return 'Event Is Closed'
              }
            }
            const textToast = funcMessage()
            return toast(textToast, {
              onClose: () => {
                window.location.reload()
              },
              toastId: textToast,
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              type: 'error',
            })
          }
          const funcRejectTimeOut = () => {
            if (status === 500) {
              if (data) {
                const { result } = data
                if (result === '50100: event is already expired') {
                  this.setState({ isLoading: false })
                  funcToastEventIsClosed()
                }
              }
            } else if (status === 200) {
              if (data) {
                const { result } = data
                if (result.status === 'UpdateSuccess') {
                  this.setState({ isLoading: false })
                  toastActive(result.message)
                  this.getEventSupplier()
                  this.setState({ isErrOther: false, isErrReasonAll: false })
                  this.props.history.push(ROUTE_PATH.SOURCING_SUPPLIER.LINK)
                } else if (result.status === 'DateExpired') {
                  this.setState({ isLoading: false })
                  funcToastEventIsClosed()
                } else if (result.status === 'EventCancelled') {
                  this.setState({ isLoading: false })
                  funcToastEventIsClosed('Event is cancelled')
                } else {
                  this.setState({ isLoading: false })
                  funcToastEventIsClosed()
                }
              }
            } else {
              this.setState({ isLoading: false })
              funcToastEventIsClosed()
            }
          }

          const funcRejectAuctionTimeOut = () => {
            if (status === 'UpdateSuccess') {
              this.setState({ isLoading: false })
              toastActive(res.message)
              this.getEventSupplier()
              this.setState({ isErrOther: false, isErrReasonAll: false })
              this.props.history.push(ROUTE_PATH.SOURCING_SUPPLIER.LINK)
            }

            if (res === '53004: start date before time now') {
              this.setState({ isLoading: false })
              toastFail('Start date before time now')
            }
          }
          try {
            if (eventType === 1) {
              funcRejectTimeOut(data)
            }
            if (eventType === 2) {
              funcRejectAuctionTimeOut()
            }
          } catch (error) {
            this.setState({ isLoading: false })
            console.log(error)
          }
        }
      }
    } catch (error) {
      this.setState({ isLoading: false })
      throw ('update suppiler fail', error)
    }
  }

  onClickRejectItem = (formikSetvalue, event, i, sumItemSuppliers) => {
    // console.log('Reject one item')
    const rejectItem = event
    let { getRFQItem } = this.state
    let countReject = 0

    // console.log({ sumItemSuppliers })
    sumItemSuppliers.map((e, i) => {
      if (e.is_reject == false) {
        return (countReject = countReject + 1)
      }
    })
    if (countReject === 1) {
      this.toggleModal('reject-all'), document.body.classList.add('modal-open')
      this.setState({
        isRejectIndex: i,
      })
    } else {
      this.setState({
        rejectItem,
        sumItemSuppliers,
        getRFQItem,
        isRejectIndex: i,
      })
      this.toggleModal('reject-item'), document.body.classList.add('modal-open')
    }
  }

  onClickQuoteItem = rejectItem => {
    // rejectItem.reject_reason = ''
    this.setState({
      rejectItem,
    })
    this.toggleModal('confirm'), document.body.classList.add('modal-open')
  }

  onClickQuote = quoteData => {
    this.toggleModal('confirm-all'), document.body.classList.add('modal-open')
    this.setState({
      quoteData,
    })
  }

  onClickConfirm = quoteData => {
    let { getRFQItem, getAuctionItem, eventType } = this.state

    if (eventType === 1) {
      getRFQItem.rfq_supplier_response_status = 'Draft'
      quoteData.rfq_supplier_response_status = 'Draft'
      getRFQItem.note_to_buyer = ''
      quoteData.item_suppliers.map(e => {
        e.is_reject = false
        e.unit_price = '0'
        e.total_price = '0'
        e.reject_reason = ''
        e.note_to_buyer = ''
      })
    }
    if (eventType === 2) {
      getAuctionItem.auction_supplier_response_status = 'Draft'
      quoteData.auction_supplier_response_status = 'Draft'
      getAuctionItem.note_to_buyer = ''
      quoteData.item_suppliers.map(e => {
        e.is_reject = false
        e.unit_price = '0'
        e.total_price = '0'
        e.reject_reason = ''
        e.note_to_buyer = ''
      })
    }

    this.setState({
      quoteData,
      getRFQItem,
      getAuctionItem,
    })
  }
  matchValueSelected = (option, selectedId) => {
    return option.find(
      value => value.value.toString() === selectedId.toString()
    )
  }

  renderItemButtom = (itemDetail = {}, index = 0, e, setFieldValue) => {
    // console.log({ itemDetail })
    if (itemDetail) {
      const showButtonQuote =
        itemDetail.item_suppliers[index].is_reject === true
      const hideButtonReject =
        itemDetail.rfq_status_id === 4 ||
        itemDetail.rfq_status_id === 5 ||
        itemDetail.is_cancel === true
      if (hideButtonReject) return
      if (showButtonQuote) {
        return (
          <Button
            className="theme-blue"
            onClick={() => {
              this.onClickQuoteItem(itemDetail.item_suppliers[index])
            }}
          >
            Quote Item
          </Button>
        )
      }
      if (!hideButtonReject && !showButtonQuote) {
        return (
          <Button
            className="theme-red"
            onClick={() => {
              // const item_supplier = itemDetail.item_suppliers[index]
              // item_supplier.unit_price = ''
              // item_supplier.rfq_supplier_item_file = []

              // itemDetail.item_suppliers[index] = item_supplier

              this.onClickRejectItem(
                setFieldValue,
                e,
                index,
                itemDetail.item_suppliers
              )
            }}
          >
            Reject item
          </Button>
        )
      }
    }
  }

  validateEventItemFormSchema = () => {
    const schema = yup.object().shape({
      is_reject: yup.boolean(),
      item_suppliers: yup.array().of(
        yup.object().shape({
          unit_price: yup
            .string()
            .required(STRING.INVALID)
            .trim()
            .when('is_reject', {
              is: false,
              then: yup
                .string()
                .test(
                  'value',
                  '0 is not allowed',
                  val => parseFloat(val) !== 0
                ),
            }),
        })
      ),
    })
    return schema
  }

  renderHeaderTableItems = (suppliersEventData = {}) => {
    return (
      <Table.TBODY>
        <Table.TR className="header">
          <Table.TH className="no">NO.</Table.TH>

          <Table.TH className="item-name">ITEM NAME</Table.TH>

          <Table.TH className="description">ITEM DESCRIPTION</Table.TH>

          <Table.TH className="quantity">QTY</Table.TH>

          <Table.TH className="uom">UOM</Table.TH>

          <Table.TH className="unit-price">
            UNIT PRICE
            <br />
            {suppliersEventData.currency}
          </Table.TH>

          <Table.TH className="total-price">
            TOTAL PRICE <br />
            {suppliersEventData.currency}
          </Table.TH>

          <Table.TH className="attachment">ATTACHMENT</Table.TH>

          <Table.TH className="note-buyer">NOTE TO BUYER</Table.TH>
          <Table.TH className="status">&nbsp;</Table.TH>
        </Table.TR>
      </Table.TBODY>
    )
  }

  renderPagePaginationList = (resetForm, setFieldValue, itemSupplier) => {
    const { total_record } = this.state

    return (
      total_record > 10 && (
        <Section className="content-footer">
          <Section className="showing-item">
            Showing {(this.state.activePage - 1) * 10 + 1} to{' '}
            {this.state.activePage > Math.floor(total_record / 10)
              ? (this.state.activePage - 1) * 10 + (total_record % 10)
              : this.state.activePage * 10}{' '}
            of {total_record} items
          </Section>
          <Section className="paginate-wrapper">
            <Paginate
              activePage={this.state.activePage}
              itemsCountPerPage={this.state.limit}
              totalItemsCount={total_record}
              onChange={e => {
                resetForm()
                // setValueUnit()
                return this.changePage(
                  e,
                  setFieldValue
                  // formData.step2.eventInformation.eventId
                )
              }}
            />
            <Section className="moveto-wrapper">
              <NumberFormat
                value={this.state.searchPage}
                label="Page"
                isHorizontal
                className="paginate-moveto"
                defaultValue="1"
                maxLength="4"
                customInput={Input}
                decimalSeparator={false}
                allowNegative={false}
                allowLeadingZeros={false}
                onChange={e => {
                  if (this._isMounted) {
                    return this.setState({
                      searchPage:
                        parseInt(e.target.value) >
                        Math.floor(total_record / 10) + 1
                          ? Math.floor(total_record / 10) + 1
                          : parseInt(e.target.value),
                    })
                  }
                }}
                isAllowed={values => {
                  // return isAllowedChangePage(values, this.props.maximum)
                }}
              />
              <Button
                onClick={() => {
                  if (this.state.searchPage) {
                    return this.changePage(
                      this.state.searchPage
                      // formData.step2.eventInformation.eventId
                    )
                  }
                }}
              >
                go
              </Button>
            </Section>
          </Section>
        </Section>
      )
    )
  }

  renderTableItems = props => {
    const { getRFQItem } = this.state
    const { values, errors, setFieldValue, handleBlur, setErrors } = props

    return values.item_suppliers.map((e, i) => {
      return (
        <Table.TR key={i}>
          <Table.TD className="no">
            {this.state.offset_page ? this.state.offset_page + i + 1 : i + 1}
          </Table.TD>
          <Table.TD className="item-name">{e.name}</Table.TD>

          <Table.TD className="description">
            <Section className="description-item">{e.description}</Section>
            {this.renderFileBuyerItem(e.rfq_buyer_item_file || [])}
          </Table.TD>

          <Table.TD className="quantity">
            {parseFloat(e.req_amount).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}
          </Table.TD>

          <Table.TD className="uom">{e.uom}</Table.TD>

          <Table.TD
            className={`unit-price form-group ${
              this.renderErrorMessageUnitPrice(errors, i) && 'is-error'
            }`}
          >
            {e.is_reject === true ? (
              <React.Fragment>
                <span className="reject-text">Reject</span>
                <Section className="message">{errors.unit_price}</Section>
              </React.Fragment>
            ) : values.rfq_status_id === 4 ||
              values.rfq_status_id === 5 ||
              values.is_cancel == true ? (
              <React.Fragment>
                <Input
                  type="text"
                  name="unit_price"
                  value={Numeral(
                    Number(props.values.item_suppliers[i].unit_price)
                  ).format('0,0.0000')}
                  disabled
                />

                <Section className="message">
                  {this.renderErrorMessageUnitPrice(errors, i)}
                </Section>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Section className="input-control number-format">
                  <NumberFormat
                    thousandSeparator={true}
                    allowLeadingZeros={false}
                    allowNegative={false}
                    customInput={Input}
                    decimalScale={4}
                    name="unit_price"
                    maxLength={18}
                    onBlur={handleBlur('unit_price')}
                    placeholder="0.0000"
                    inputmode="numeric"
                    isAllowed={values => {
                      const { value, floatValue } = values

                      if (
                        typeof floatValue === 'undefined' ||
                        typeof value === 'undefined'
                      ) {
                        return true
                      }
                      // if (floatValue === 0) {
                      //   return false
                      // }
                      if (value.charAt(0) === '0') {
                        if (value.charAt(1) && value.charAt(1) != '.') {
                          return false
                        }
                      }
                      if (this.props.maximum) {
                        return floatValue <= this.props.maximum
                      } else {
                        return true
                      }
                    }}
                    onChange={element => {
                      let err =
                        errors && errors.item_suppliers
                          ? errors.item_suppliers
                          : []
                      if (parseFloat(element.target.value) === 0) {
                        err[i] = {
                          unit_price: '0 is not allowed',
                        }
                      } else {
                        if (err.length > 0 && err[i]) {
                          err[i] = {
                            unit_price: '',
                          }
                        }
                      }
                      if (err.length > 0) {
                        setErrors({
                          err,
                        })
                      }
                      this.setInputArray(setFieldValue, element, i, values)
                    }}
                    value={props.values.item_suppliers[i].unit_price}
                  />
                </Section>
                <Section className="message">
                  {this.renderErrorMessageUnitPrice(errors, i)}
                </Section>
              </React.Fragment>
            )}
          </Table.TD>

          <Table.TD className="total-price">
            <Text
              tootipValue={this.renderTotalPriceItem(values.item_suppliers[i])}
              useTootipFor="total-price"
              useTootip={true}
            >
              {this.renderTotalPriceItem(values.item_suppliers[i])}
            </Text>
          </Table.TD>

          <Table.TD className="attachment" style={{ textAlign: 'unset' }}>
            {values.rfq_status_id === 4 ||
            values.rfq_status_id === 5 ||
            values.is_cancel == true ? (
              values.item_suppliers[i].event_supplier_item_files == null && (
                <Section className="rfq-status-attach">-</Section>
              )
            ) : (
              <AttachedFile
                maxFileSizeMb={50}
                isDisableInput={
                  props.values.item_suppliers[i].is_reject === true
                    ? true
                    : false
                }
                id={`attach-file-item-${i}`}
                classNameInput={'form-group-inner-wrapper tooltip-upload'}
                onSelect={async (file, e, cb) => {
                  if (file != null) {
                    const params = {
                      file,
                      name: file.name,
                    }
                    const supplierItemFiles = await eventNewController().rfqSupplierItemFile(
                      params
                    )
                    // console.log({
                    //   supplierItemFiles,
                    // })
                    if (supplierItemFiles === '4010: File contains code') {
                      toast.error('Wrong file format.')
                      this.setInputArrayUploadFile(
                        file,
                        i,
                        values,
                        setFieldValue
                      )
                    } else if (supplierItemFiles) {
                      // console.log({
                      //   fileItem: values.item_suppliers[i],
                      // })
                      values.item_suppliers[i].event_supplier_item_files.push({
                        name: supplierItemFiles.name,
                        id: supplierItemFiles.id,
                        is_deleted: false,
                      })
                      this.setInputArrayUploadFile(
                        file,
                        i,
                        values,
                        setFieldValue
                      )
                    }
                  }
                }}
                className={'attached-file-list'}
                isIcon={true}
                fileList={
                  values.item_suppliers[i].event_supplier_item_files || []
                }
                hasRemove={values.rfq_status_id != 4 ? true : false}
                onClickRemove={e => {
                  this.deleteArrayFile(setFieldValue, props.values, e, i, e.id)
                  this.forceUpdate()
                }}
                onDownload={e => {
                  // console.log({ download: e })
                  this.setLoadingDownloadFile(e)
                  this.downloadSupplierAttachmentItem(e)
                }}
              />
            )}
          </Table.TD>

          <Table.TD className="note-buyer">
            {props.values.item_suppliers[i].is_reject === true ||
            values.rfq_status_id === 4 ||
            values.rfq_status_id === 5 ||
            values.is_cancel == true ? (
              <InputTextarea
                name="note_to_buyer"
                value={
                  props.values.item_suppliers[i].reject_reason
                    ? props.values.item_suppliers[i].reject_reason
                    : props.values.item_suppliers[i].note_to_buyer
                    ? props.values.item_suppliers[i].note_to_buyer
                    : '-'
                }
                disabled={true}
              ></InputTextarea>
            ) : (
              <InputTextarea
                name="note_to_buyer"
                value={props.values.item_suppliers[i].note_to_buyer}
                onChange={e => {
                  this.setNoteArray(setFieldValue, e, i)
                }}
              ></InputTextarea>
            )}
          </Table.TD>
          <Table.TD
            className="status"
            style={{
              padding: '19px 0',
              display: 'flex',
            }}
          >
            {this.renderItemButtom(values, i, e, setFieldValue)}
          </Table.TD>
        </Table.TR>
      )
    })
  }

  renderErrorMessageUnitPrice = (errors, i) => {
    // console.log(errors)
    if (errors && errors.item_suppliers) {
      const errorUnitPrice =
        errors.item_suppliers[i] && errors.item_suppliers[i].unit_price
      if (errorUnitPrice) {
        return errors.item_suppliers[i].unit_price
      }
    }
  }

  renderFileBuyerItem = (buyerItemFiles = []) => {
    const { loadingDownloadFile } = this.state
    return (
      <AttachedFile
        isUpload={false}
        fileList={buyerItemFiles || []}
        isIcon={true}
        hasRemove={false}
        className="attached-file-list"
        onDownload={e => {
          this.setLoadingDownloadFile(e)
          this.downloadAttachmentItem(e)
        }}
        loadingDownload={loadingDownloadFile}
      />
    )
  }

  totalPrice = (item_suppliers = []) => {
    if (item_suppliers.length > 0) {
      const result = item_suppliers.reduce((sum, number) => {
        return parseFloat(sum) + parseFloat(number.total_price)
      }, 0)
      return result
    }
  }

  totalPriceAuction = (item_suppliers = []) => {
    if (item_suppliers.length > 0) {
      const result = item_suppliers.reduce((sum, number) => {
        return parseFloat(sum) + parseFloat(number.total_price)
      }, 0)
      return Numeral(result).format('0,0.00')
    }
  }

  renderGrandTotalPrice = (totalPrice, itemSuppliers) => {
    // const { getRFQItem, priceRFQItemHistory, acceptRFQItem } = this.state

    // console.log({ totalPrice, getRFQItem, itemSuppliers })
    if (
      isNaN(totalPrice) ||
      isNaN(this.totalPrice(itemSuppliers)) ||
      this.totalPrice(itemSuppliers) == '0.00'
    ) {
      return '0.00'
    } else {
      return parseFloat(this.totalPrice(itemSuppliers)).toLocaleString(
        undefined,
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      )
    }
    // }
  }

  renderTotalPriceItem = (itemSupplier = {}) => {
    const { priceRFQItemHistory } = this.state
    if (itemSupplier) {
      const { is_reject, total_price } = itemSupplier
      const DEFAULT_ISREJECT = '-'
      const DEFAULT_PRICE = '0.00'

      if (is_reject === true) {
        return DEFAULT_ISREJECT
      } else if (
        isNaN(total_price) ||
        total_price === '0.00' ||
        total_price === ''
      ) {
        return DEFAULT_PRICE
      } else {
        return parseFloat(total_price).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }
    }
  }

  modalConfirmResponse = (formData = {}) => {
    const { modals, clicks, eventType } = this.state
    return (
      <Modal
        id="confirm-response"
        className="theme-blue"
        isOpen={
          modals
            .filter(modal => {
              return modal.name === 'confirm-response'
            })
            .map(obj => obj.isOpen)[0]
        }
        modalWidth="575px"
      >
        <Modal.Header>
          {eventType === 1 ? 'Confirm' : 'Auction Event Confirmation'}
        </Modal.Header>

        <Modal.Body>
          <p className="default text-center">
            {eventType === 1
              ? 'Are you sure to response?'
              : 'Are you sure to accept auction invitation?'}
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="theme-border-gray"
            onClick={() => {
              this.toggleModal('confirm-response'),
                document.body.classList.remove('modal-open')
            }}
          >
            Cancel
          </Button>
          {clicks >= 1 ? (
            <Button
              className="theme-green"
              onClick={() => {
                this.toggleModal('confirm-response')
                document.body.classList.remove('modal-open')
              }}
            >
              Confirm
            </Button>
          ) : (
            <Button
              className="theme-green"
              onClick={e => {
                this.onClickSaveData(formData)
                this.setState(function (previousState, currentProps) {
                  return {
                    clicks: previousState.clicks + 1,
                  }
                })
                this.toggleModal('confirm-response')
                document.body.classList.remove('modal-open')
              }}
            >
              Confirm
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    )
  }
  renderSourcingDetailFormSupplier = () => {
    const {
      modals,
      suppliersEventData,
      suppliersEvent,
      getBuyerData,
      getSupplier,
      getRFQItem,
      getAuctionItem,
      getDownloadFileBuyerInfo,
      getSupplierEventFile,
      supplierEventFile,
      agreeConditions,
      rejectItem,
      reasonStatus,
      sumItemSuppliers,
      quoteData,
      formData,
      isErrReason,
      isErrOther,
      isErrReasonAll,
      isQuote,
      eventType,
      dateWithin24,
      bidHistoryOfSupplier,
    } = this.state
    // console.log('getAuctionItem', getAuctionItem)
    const funcRenderPageTitle = () => {
      const funconClickBuyerManagement = e => {
        return this.props.history.push(ROUTE_PATH.HOME.LINK)
      }
      const funconClickSupplier = e => {
        return this.props.history.push(ROUTE_PATH.SOURCING_SUPPLIER.LINK)
      }
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_buyer_management"
                // src={ICONS['icon-company-white.svg']}
                src={ICONS['icon-sourcing-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section id="page_title_buyer_management" className="title">
                {/* RFQ */}
                Sourcing
              </Section>

              <Section
                id="page_breadcrumb_buyer_management"
                className="breadcrumbs"
              >
                <Button
                  className="breadcrumb"
                  onClick={funconClickBuyerManagement}
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button className="breadcrumb" onClick={funconClickSupplier}>
                  {/* <span>RFQ</span> */}
                  <span>Sourcing</span>
                </Button>
                <Button className="breadcrumb current">
                  {/* <span>RFQ Information</span> */}
                  <span>Event Details</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>
      )
    }
    const funcRenderPageContent = () => {
      const funcloadingContent = () => {
        const funcOnClickModalBuyerInfo = e => {
          this.toggleModal('buyer-info')
          return document.body.classList.add('modal-open')
        }
        const funcValueSuppliersEvent = () => {
          if (suppliersEvent) {
            return suppliersEvent.code
          } else {
            return null
          }
        }
        const valueSuppliersEvent = funcValueSuppliersEvent()
        // ValueSuppliersRfqIDName
        const funcValueSuppliersRfqIDName = () => {
          if (suppliersEventData) {
            return suppliersEventData.name
          } else {
            return null
          }
        }
        const valueSuppliersRfqIdName = funcValueSuppliersRfqIDName()
        // ValueGetBuyer
        const funcValueGetBuyer = () => {
          if (getBuyerData) {
            return getBuyerData.company.company_name_eng
          } else {
            return null
          }
        }
        const valueGetBuyer = funcValueGetBuyer()
        // ValueSupDescription
        const funcValueSupDescription = () => {
          if (suppliersEventData) {
            return suppliersEventData.description
          } else {
            return null
          }
        }
        const valueSupDescription = funcValueSupDescription()
        // funcValueSupEventType
        const funcValueSupEventType = () => {
          if (suppliersEvent) {
            return suppliersEvent.event_type
          } else {
            return null
          }
        }
        const valueSupEventType = funcValueSupEventType()
        const funcClassInnerWrapper = () => {
          if (getRFQItem.rfq_status_id === 5) {
            return 'form-group-inner-wrapper rfq_status'
          } else {
            return 'form-group-inner-wrapper'
          }
        }
        const classInnerWrapperRfqStatus = funcClassInnerWrapper()
        const funcRenderRfqStatusId = () => {
          if (getRFQItem.rfq_status_id === 5) {
            return (
              <Image
                src={ICONS['icon-help.svg']}
                alt="help"
                tootipValue={getRFQItem.cancel_reason}
                useTootipFor="FileType"
                useTootip={true}
              />
            )
          } else {
            return null
          }
        }
        // funcValueFullName
        const funcValueFullName = () => {
          if (getBuyerData) {
            return getBuyerData.full_name
          } else {
            return null
          }
        }
        const vlaueFullName = funcValueFullName()
        const funcDownloadFileBuyerInfo = () => {
          if (getDownloadFileBuyerInfo) {
            const onClickdownloadAttachment = e => {
              this.setLoadingDownloadFile(e)
              return this.downloadAttachment(e)
            }
            if (getDownloadFileBuyerInfo.length > 0) {
              return (
                <AttachedFile
                  isUpload={false}
                  fileList={getDownloadFileBuyerInfo || []}
                  onDownload={e => onClickdownloadAttachment(e)}
                  className={'attached-file-list'}
                  isIcon={true}
                  loadingDownload={this.state.loadingDownloadFile}
                />
              )
            } else {
              return '-'
            }
          } else {
            return null
          }
        }

        return (
          <Section className="form-wrapper">
            <Section className="form-group-title">Event Information</Section>

            {/* row head Event information  */}
            <Section className="form-row">
              <Section className="form-col col-6">
                {/* head Event Information */}
                <Section className="form-group-header">
                  Event Information
                </Section>
              </Section>
              <Section className="form-col col-6"></Section>
            </Section>
            {/* row event no. to event status */}
            <Section className="form-row">
              <Section className="form-col col-6">
                {/* Event No. */}
                <Section className="form-group">
                  <label>Event No.</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input
                        type="text"
                        disabled={true}
                        value={valueSuppliersEvent}
                      />
                    </Section>

                    <Section className="message">error</Section>
                  </Section>
                </Section>
                {/* Event Name */}
                <Section className="form-group">
                  <label>Event Name</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input
                        type="text"
                        disabled={true}
                        value={valueSuppliersRfqIdName}
                      />
                    </Section>

                    <Section className="message">error</Section>
                  </Section>
                </Section>
              </Section>
              <Section className="form-col col-6">
                {/* Event Type  */}
                <Section className="form-group">
                  <label>Event Type</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input
                        type="text"
                        disabled={true}
                        value={valueSupEventType}
                      />
                    </Section>

                    <Section className="message">error</Section>
                  </Section>
                </Section>
                {/* Event Status */}
                <Section className="form-group">
                  <label>Event Status</label>

                  <Section className="form-group-control">
                    <Section className={classInnerWrapperRfqStatus}>
                      <Input
                        type="text"
                        disabled={true}
                        value={
                          suppliersEventData
                            ? suppliersEventData.rfq_status ||
                              suppliersEventData.auction_status
                            : null
                        }
                      />
                      {funcRenderRfqStatusId()}
                    </Section>

                    <Section className="message">error</Section>
                  </Section>
                </Section>
              </Section>
            </Section>
            {valueSupEventType === 'RFQ' ? (
              // RFQ
              <>
                {/* row description to end date  */}
                <Section className="form-row">
                  <Section className="form-col col-6">
                    {/* Description */}
                    <Section className="form-group">
                      <label>Description</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <InputTextarea
                            disabled={true}
                            value={
                              valueSupDescription ? valueSupDescription : '-'
                            }
                          />
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>
                    {/* Response Status */}
                    <Section className="form-group">
                      <label>Response Status</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper rfq_status">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              getSupplier
                                ? getSupplier.rfq_supplier_response_status_id ===
                                    2 ||
                                  getSupplier.rfq_supplier_response_status_id ===
                                    3
                                  ? 'No Response'
                                  : getSupplier.rfq_supplier_response_status
                                : null
                            }
                          />
                          {getSupplier &&
                            getSupplier.rfq_supplier_response_status_id ===
                              6 && (
                              <Image
                                src={ICONS['icon-help.svg']}
                                alt="help"
                                tootipValue={getSupplier.reject_reason}
                                useTootip={true}
                              />
                            )}
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>
                  </Section>
                  <Section className="form-col col-6">
                    {/* Bidding type */}
                    <Section className="form-group ">
                      <label>Bidding Type</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={suppliersEventData.bidding_type}
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>
                    {/* Start Date */}
                    <Section className="form-group ">
                      <label>Start Date</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              suppliersEventData
                                ? dateMonDayYearTime(
                                    suppliersEventData.start_date
                                  )
                                : null
                            }
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>
                    {/* End Date */}
                    <Section className="form-group">
                      <label>End Date</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              suppliersEventData
                                ? dateMonDayYearTime(
                                    suppliersEventData.end_date
                                  )
                                : null
                            }
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>
                  </Section>
                </Section>

                {/* row currency to attachment  */}
                <Section className="form-row">
                  <Section className="form-col col-6">
                    {/* Currency */}
                    <Section className="form-group">
                      <label>Currency</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              suppliersEventData
                                ? suppliersEventData.currency
                                : null
                            }
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>

                    {/* VAT */}
                    <Section className="form-group">
                      <label>VAT</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              suppliersEventData ? suppliersEventData.vat : null
                            }
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>

                    {/* Note to Supplier */}
                    <Section className="form-group">
                      <label>Note to Supplier</label>
                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <InputTextarea
                            disabled={true}
                            value={
                              suppliersEventData
                                ? suppliersEventData.note_to_supplier
                                  ? suppliersEventData.note_to_supplier
                                  : '-'
                                : '-'
                            }
                          ></InputTextarea>
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    {/* Attachment */}
                    <Section className="form-group attachment-row">
                      <label>Attachment</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          {funcDownloadFileBuyerInfo()}
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>
                  </Section>
                  <Section className="form-col col-6">
                    {/* head Note to buyer for this event  */}
                    <Section className="form-group-header grid-to-label">
                      Note to buyer for this event
                    </Section>
                    {/* Note to Buyer */}
                    <Section className="form-group">
                      <label>
                        Note to Buyer
                        <br />
                        (Optional)
                      </label>
                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          {getRFQItem.rfq_status_id === 4 ||
                          getRFQItem.is_cancel == true ||
                          (getRFQItem.rfq_supplier_response_status ===
                            'Rejected' &&
                            isQuote === false) ? (
                            <InputTextarea
                              value={
                                getRFQItem.note_to_buyer
                                  ? getRFQItem.note_to_buyer
                                  : '-'
                              }
                              onChange={e => {
                                getRFQItem.note_to_buyer = e.target.value
                                this.setState({
                                  getRFQItem,
                                })
                              }}
                              disabled={true}
                            ></InputTextarea>
                          ) : (
                            <InputTextarea
                              value={getRFQItem.note_to_buyer}
                              onChange={e => {
                                getRFQItem.note_to_buyer = e.target.value
                                this.setState({
                                  getRFQItem,
                                })
                              }}
                            ></InputTextarea>
                          )}
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>
                    {/* Attachment */}
                    <Section className="form-group attachment-row">
                      <label>
                        Attachment <br />
                        (Optional)
                      </label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper tooltip-upload">
                          {(getRFQItem.rfq_status_id &&
                            getRFQItem.rfq_status_id === 4) ||
                          (getRFQItem.rfq_status_id &&
                            getRFQItem.rfq_status_id === 5) ? null : (
                            <React.Fragment>
                              <AttachedFile
                                isShow={false}
                                isHelp={true}
                                id="attach-to-buyer"
                                isDisableInput={
                                  getRFQItem.rfq_supplier_response_status ===
                                    'Rejected' && isQuote === false
                                    ? true
                                    : false
                                }
                                onSelect={(file, e, cb) => {
                                  // console.log('file', file)
                                  if (file != null) {
                                    this.setUploadEventFile(file)
                                  }
                                }}
                                fileList={[]}
                              />
                            </React.Fragment>
                          )}
                        </Section>
                        {supplierEventFile && supplierEventFile.length > 0 ? (
                          <AttachedFile
                            id="attached-event-file"
                            isUpload={false}
                            fileList={this.state.supplierEventFile || []}
                            className="attached-file-list"
                            hasRemove={
                              (getRFQItem.rfq_status_id &&
                                getRFQItem.rfq_status_id === 4) ||
                              (getRFQItem.rfq_status_id &&
                                getRFQItem.rfq_status_id === 5) ||
                              getRFQItem.rfq_supplier_response_status ===
                                'Reject'
                                ? false
                                : true
                            }
                            onClickRemove={e => {
                              if (e.id) {
                                e.is_deleted = true
                                e.status = false
                                this.setState({
                                  supplierEventFile,
                                })
                                this.forceUpdate()
                              }
                            }}
                            isIcon={true}
                            onDownload={e => {
                              this.setLoadingDownloadFile(e)
                              this.downloadSupplierEventFile(e)
                            }}
                          />
                        ) : getRFQItem.rfq_status_id &&
                          getRFQItem.rfq_status_id !== 3 ? (
                          '-'
                        ) : null}
                      </Section>
                    </Section>
                  </Section>
                </Section>
              </>
            ) : (
              // Auction
              <>
                {/* row description to biding type  */}
                <Section className="form-row">
                  <Section className="form-col col-6">
                    {/* Description */}
                    <Section className="form-group">
                      <label>Description</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <InputTextarea
                            disabled={true}
                            value={
                              valueSupDescription ? valueSupDescription : '-'
                            }
                          />
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>
                  </Section>
                  <Section className="form-col col-6">
                    {/* Auction type */}
                    <Section className="form-group ">
                      <label>Auction Type</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={suppliersEventData.auction_type}
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>
                    {/* Bidding type */}
                    <Section className="form-group ">
                      <label>Bidding Type</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={suppliersEventData.bidding_type}
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>
                  </Section>
                </Section>

                {/* row Response Status to End Date  */}
                <Section className="form-row">
                  <Section className="form-col col-6">
                    {/* Response Status */}
                    <Section className="form-group">
                      <label>Response Status</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper rfq_status">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              getSupplier
                                ? getSupplier.auction_supplier_response_status_id ===
                                    2 ||
                                  getSupplier.auction_supplier_response_status_id ===
                                    3
                                  ? 'No Response'
                                  : getSupplier.auction_supplier_response_status
                                : null
                            }
                          />
                          {/* ToDo */}
                          {getSupplier &&
                            getSupplier.auction_supplier_response_status_id ===
                              6 && (
                              <Image
                                src={ICONS['icon-help.svg']}
                                alt="help"
                                tootipValue={getSupplier.reject_reason}
                                useTootip={true}
                              />
                            )}
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>

                    {/* Currency */}
                    <Section className="form-group">
                      <label>Currency</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              suppliersEventData
                                ? suppliersEventData.currency
                                : null
                            }
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>

                    {/* VAT */}
                    <Section className="form-group">
                      <label>VAT</label>
                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              suppliersEventData ? suppliersEventData.vat : null
                            }
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>

                    {/* Note to Supplier */}
                    <Section className="form-group">
                      <label>Note to Supplier</label>
                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <InputTextarea
                            disabled={true}
                            value={
                              suppliersEventData
                                ? suppliersEventData.note_to_supplier
                                  ? suppliersEventData.note_to_supplier
                                  : '-'
                                : '-'
                            }
                          ></InputTextarea>
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    {/* Attachment */}
                    <Section className="form-group attachment-row">
                      <label>Attachment</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          {funcDownloadFileBuyerInfo()}
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>
                  </Section>

                  <Section className="form-col col-6">
                    {/* Opening Price */}
                    <Section className="form-group">
                      <label>Opening Price</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <NumberFormat
                            type="text"
                            value={
                              suppliersEventData
                                ? Number(
                                    suppliersEventData.opening_price
                                  ).toFixed(2)
                                : null
                            }
                            thousandSeparator={true}
                            customInput={Input}
                            disabled={true}
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>

                    {/* Bid submission */}
                    <Section className="form-group">
                      <label>
                        {suppliersEventData.bidding_type === 'Reverse'
                          ? suppliersEventData.is_min_bid_used
                            ? 'Minimum Bid Decrement'
                            : 'Bid Decrement'
                          : suppliersEventData.is_min_bid_used
                          ? 'Minimum Bid Increment'
                          : 'Bid Increment'}
                      </label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <NumberFormat
                            type="text"
                            value={
                              suppliersEventData
                                ? Number(
                                    suppliersEventData.bid_decrement_increment ||
                                      suppliersEventData.min_bid_decrement_increment
                                  ).toFixed(2)
                                : null
                            }
                            thousandSeparator={true}
                            customInput={Input}
                            disabled={true}
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>

                    {/* Extension Time */}
                    <Section className="form-group">
                      <label>
                        Extension Time
                        <br />
                        (Minutes)
                      </label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              suppliersEventData.extension_minutes != null
                                ? suppliersEventData.extension_minutes +
                                  ' Minutes'
                                : '-'
                            }
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>

                    {/* Max Extension time */}
                    <Section className="form-group">
                      <label style={{ letterSpacing: '-0.1px' }}>
                        Max Extension Time
                      </label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              suppliersEventData.extension_minutes
                                ? suppliersEventData.extension_time
                                  ? suppliersEventData.extension_time + ' Times'
                                  : suppliersEventData.extension_time_string
                                : '-'
                            }
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>

                    {/* Start Date */}
                    <Section className="form-group ">
                      <label>Start Date</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              suppliersEventData
                                ? dateMonDayYearTime(
                                    suppliersEventData.start_date
                                  )
                                : null
                            }
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>
                    {/* End Date */}
                    <Section className="form-group">
                      <label>End Date</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={
                              suppliersEventData
                                ? dateMonDayYearTime(
                                    suppliersEventData.end_date
                                  )
                                : null
                            }
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>
                  </Section>
                </Section>
              </>
            )}

            <Section className="form-row">
              <Section className="form-col col-6">
                {/* head Buyer company  */}
                <Section className="form-group-header grid-to-label">
                  Buyer Company
                </Section>
                {/* Buyer Name  */}
                <Section className="form-group">
                  <label>Buyer Name</label>
                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input
                        type="text"
                        disabled={true}
                        value={valueGetBuyer}
                      />
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>
                {/* Information */}
                <Section className="form-group">
                  <label></label>
                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Button
                        className="theme-blue"
                        onClick={funcOnClickModalBuyerInfo}
                      >
                        Information
                      </Button>
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>
              </Section>
              <Section className="form-col col-6">
                {/* head Buyer Contact */}
                <Section className="form-group-header grid-to-label">
                  Buyer Contact
                </Section>
                {/* Contact Name */}
                <Section className="form-group">
                  <label>Contact Name</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input
                        type="text"
                        disabled={true}
                        value={vlaueFullName}
                      />
                    </Section>

                    <Section className="message">error</Section>
                  </Section>
                </Section>
                {/* Email */}
                <Section className="form-group">
                  <label>Email</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input
                        type="text"
                        disabled={true}
                        value={getBuyerData ? getBuyerData.email : null}
                      />
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>
                {/* Tel */}
                <Section className="form-group">
                  <label>Tel</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      {/* fix phone data */}
                      <Input
                        type="text"
                        disabled={true}
                        value={
                          getBuyerData
                            ? getBuyerData.phone
                              ? getBuyerData.phone
                              : '-'
                            : null
                        }
                      />
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>
              </Section>
            </Section>
            {valueSupEventType === 'RFQ' ? (
              <>
                {/* row  button upload and download excel  */}
                <Section className="form-row" style={{ marginBottom: '20px' }}>
                  {/* {getRFQItem.rfq_status_id === 3 ||
              getRFQItem.is_cancel == false ||
              (getRFQItem.rfq_supplier_response_status === 'Draft' &&
                isQuote === false) ? ( */}
                  {getRFQItem.rfq_status_id === 3 &&
                  getRFQItem.rfq_supplier_response_status !== 'Rejected' ? (
                    <Section
                      className="form-group-inner-wrapper"
                      style={{ justifyContent: 'flex-end' }}
                    >
                      <InputUploadExcel
                        id="upload-excel-item"
                        isHideIput={true}
                        browseButtonText="Upload Excel"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onClick={e => (e.target.value = null)}
                        onChange={async e => {
                          let files = e.target.files[0]
                          // console.log({ files })
                          let size = 50000000
                          if (files) {
                            const isFilesType = await checkFileType(files)
                            if (isFilesType) {
                              if (files.size > size) {
                                toastFail('File size exceeded 50 Mb')
                              } else {
                                this.readUploadFile(e)
                              }
                            }
                          }
                        }}
                      />

                      <Button
                        className="theme-blue page-button download-excel-button"
                        onClick={this.onClickTemplateLink}
                        style={{ marginLeft: '15px' }}
                      >
                        Download Excel
                      </Button>
                    </Section>
                  ) : (
                    <React.Fragment></React.Fragment>
                  )}
                </Section>

                <Formik
                  enableReinitialize={true}
                  initialValues={getRFQItem}
                  validationSchema={this.validateEventItemFormSchema()}
                  validateOnChange={false}
                  validateOnBlur={false}
                  onSubmit={(values, formiksAction) => {
                    this.onClickConfirmResponse(values)
                  }}
                >
                  {props => {
                    const {
                      values,
                      errors,
                      setFieldValue,
                      handleBlur,
                      submitForm,
                      resetForm,
                      setErrors,
                    } = props

                    const renderItemPage = items => {
                      // const { activePage, limit } = this.state

                      // paginate
                      // const itemList = pageData(
                      //   this.renderTableItems(props),
                      //   activePage,
                      //   10
                      // )
                      // // console.log({ itemList })
                      // return itemList

                      return this.renderTableItems(props)
                    }

                    return (
                      <Form>
                        <Section className="rfq-info table-header-freeze-wrapper">
                          <Table className="rfq-info">
                            {this.renderHeaderTableItems(suppliersEventData)}
                          </Table>
                          <FieldArray
                            name={`arrayUnitPrice`}
                            render={arrayDataHelpers => (
                              <Table className="rfq-info split-row-color">
                                <Table.TBODY>
                                  {values.item_suppliers
                                    ? renderItemPage(values)
                                    : null}
                                </Table.TBODY>
                              </Table>
                            )}
                          />
                        </Section>
                        {/* {this.renderPagePaginationList(
                          resetForm,
                          setFieldValue,
                          values.item_suppliers
                        )} */}
                        <Section className="total-price">
                          <label>Grand Total:</label>
                          {this.renderGrandTotalPrice(
                            values.total_price,
                            values.item_suppliers
                          )}
                          &nbsp;{suppliersEventData.currency}
                        </Section>

                        <Section className="form-actions">
                          <Section className="button-group">
                            {values.rfq_status_id === 4 ||
                            values.rfq_status_id === 5 ||
                            values.is_cancel == true ? null : (
                              <Button
                                className="theme-blue remove"
                                onClick={() => {
                                  this.onClickSaveDraft(values)
                                }}
                              >
                                Save Draft
                              </Button>
                            )}
                          </Section>

                          <Section className="button-group">
                            {values.rfq_status_id === 4 ||
                            values.rfq_status_id === 5 ||
                            values.is_cancel == true ? (
                              <Button
                                className="theme-border-gray"
                                onClick={() => {
                                  this.props.history.push(
                                    ROUTE_PATH.SOURCING_SUPPLIER.LINK
                                  )
                                }}
                              >
                                Close
                              </Button>
                            ) : (
                              <React.Fragment>
                                <Button
                                  className="theme-border-gray"
                                  onClick={() => {
                                    this.props.history.push(
                                      ROUTE_PATH.SOURCING_SUPPLIER.LINK
                                    )
                                  }}
                                >
                                  Cancel
                                </Button>
                                {getRFQItem.rfq_supplier_response_status ===
                                  'Rejected' && isQuote === false ? null : (
                                  <Button
                                    className="theme-blue"
                                    onClick={() => {
                                      this.setState({
                                        clicks: 0,
                                      })
                                      submitForm()
                                    }}
                                  >
                                    Response
                                  </Button>
                                )}
                                {values.rfq_supplier_response_status ===
                                  'Rejected' && isQuote === false ? (
                                  <Button
                                    className="theme-blue"
                                    onClick={() => {
                                      this.onClickQuote(values)
                                    }}
                                  >
                                    Quote
                                  </Button>
                                ) : (
                                  <Button
                                    className="theme-red"
                                    onClick={e => {
                                      if (e.detail === 1) {
                                        this.onClickReject(
                                          suppliersEvent.code,
                                          suppliersEventData.name,
                                          props.values
                                        )
                                      }
                                    }}
                                  >
                                    Reject
                                  </Button>
                                )}
                              </React.Fragment>
                            )}
                          </Section>
                        </Section>
                      </Form>
                    )
                  }}
                </Formik>
              </>
            ) : (
              <>
                {(getAuctionItem.auction_status_id === 2 ||
                  getAuctionItem.auction_status_id === 5) && (
                  <Section className="auction-info table-scroll">
                    <Table className="auction-info info fixed-header">
                      <Table.TBODY>
                        <Table.TR className="header">
                          <Table.TH className="no">NO.</Table.TH>

                          <Table.TH className="item-name">ITEM NAME</Table.TH>

                          <Table.TH className="description">
                            ITEM DESCRIPTION
                          </Table.TH>

                          <Table.TH className="quantity">QTY</Table.TH>

                          <Table.TH className="uom">UOM</Table.TH>
                        </Table.TR>
                      </Table.TBODY>
                    </Table>
                    <Table className="auction-info info split-row-color">
                      <Table.TBODY>
                        {getAuctionItem.item_suppliers
                          ? getAuctionItem.item_suppliers.map((e, i) => (
                              <Table.TR key={i}>
                                <Table.TD className="no">{i + 1}</Table.TD>
                                <Table.TD className="item-name">
                                  {e.name}
                                </Table.TD>
                                <Table.TD className="description">
                                  <Section className="description-item">
                                    {e.description
                                      ? e.description
                                      : e.auction_buyer_item_file.length > 0
                                      ? ''
                                      : '-'}
                                  </Section>
                                  {this.renderFileBuyerItem(
                                    e.auction_buyer_item_file
                                  )}
                                </Table.TD>
                                <Table.TD className="quantity">
                                  {parseFloat(e.req_amount).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                    }
                                  )}
                                </Table.TD>

                                <Table.TD className="uom">{e.uom}</Table.TD>
                              </Table.TR>
                            ))
                          : null}
                      </Table.TBODY>
                    </Table>
                  </Section>
                )}
                {getAuctionItem.auction_status_id === 3 ||
                getAuctionItem.auction_status_id === 4 ? (
                  <>
                    <Section className="auction-info table-scroll">
                      <Table className="auction-info more fixed-header">
                        <Table.TBODY>
                          <Table.TR className="header">
                            <Table.TH className="no">NO.</Table.TH>

                            <Table.TH className="item-name">ITEM NAME</Table.TH>

                            <Table.TH className="description">
                              DESCRIPTION
                            </Table.TH>

                            <Table.TH className="quantity">QUANTITY</Table.TH>

                            <Table.TH className="uom">UOM</Table.TH>
                            <Table.TH className="unit-price">
                              UNIT PRICE({suppliersEventData.currency})
                            </Table.TH>
                            <Table.TH className="total-price">
                              TOTAL PRICE({suppliersEventData.currency})
                            </Table.TH>
                          </Table.TR>
                        </Table.TBODY>
                      </Table>
                      <Table className="auction-info more split-row-color">
                        <Table.TBODY>
                          {getAuctionItem.item_suppliers
                            ? getAuctionItem.item_suppliers.map((e, i) => (
                                <Table.TR key={i}>
                                  <Table.TD className="no">{i + 1}</Table.TD>
                                  <Table.TD className="item-name">
                                    {e.name}
                                  </Table.TD>
                                  <Table.TD className="description">
                                    <Section className="description-item">
                                      {e.description
                                        ? e.description
                                        : e.auction_buyer_item_file.length > 0
                                        ? ''
                                        : '-'}
                                    </Section>
                                    {this.renderFileBuyerItem(
                                      e.auction_buyer_item_file
                                    )}
                                  </Table.TD>
                                  <Table.TD className="quantity">
                                    {parseFloat(e.req_amount).toLocaleString(
                                      undefined,
                                      {
                                        minimumFractionDigits: 2,
                                      }
                                    )}
                                  </Table.TD>

                                  <Table.TD className="uom">{e.uom}</Table.TD>
                                  <Table.TD className="unit-price">
                                    {e.unit_price
                                      ? formatNumberWithCommaN4Decimal(
                                          e.unit_price
                                        )
                                      : 'N/A'}
                                  </Table.TD>
                                  <Table.TD className="total-price">
                                    {e.total_price
                                      ? formatNumberWithCommaN2Decimal(
                                          e.total_price
                                        )
                                      : 'N/A'}
                                  </Table.TD>
                                </Table.TR>
                              ))
                            : null}
                        </Table.TBODY>
                      </Table>
                    </Section>

                    <Section className="total-price" pr={'2rem'} mt={'1rem'}>
                      <label>Grand Total:</label>
                      {this.totalPriceAuction(getAuctionItem.item_suppliers)}
                      &nbsp;{suppliersEventData.currency}
                    </Section>
                  </>
                ) : null}
                {getAuctionItem.auction_status_id === 4 ? (
                  <>
                    <Section className="form-group-title" mt="2em">
                      Bid History
                    </Section>
                    <Section className="bid-history table-scroll">
                      <Table className="bid-history fixed-header">
                        <Table.TBODY>
                          <Table.TR className="header">
                            <Table.TH className="bid-no">BIDDING NO.</Table.TH>

                            <Table.TH className="total-bid-amount">
                              TOTAL BIDDING AMOUNT({suppliersEventData.currency}
                              )
                            </Table.TH>

                            <Table.TH className="bid-time">
                              BIDDING TIME
                            </Table.TH>

                            <Table.TH className="view-more">VIEW MORE</Table.TH>
                          </Table.TR>
                        </Table.TBODY>
                      </Table>
                      <Table className="bid-history split-row-color">
                        <Table.TBODY>
                          {bidHistoryOfSupplier &&
                          bidHistoryOfSupplier.length > 0 ? (
                            bidHistoryOfSupplier.map((value, index) => (
                              <Table.TR key={index}>
                                <Table.TD className="bid-no">
                                  {bidHistoryOfSupplier.length - index}
                                </Table.TD>
                                <Table.TD className="total-bid-amount">
                                  {value.detail.bidding_amount
                                    ? formatNumberWithCommaN2Decimal(
                                        value.detail.bidding_amount
                                      )
                                    : 0}
                                </Table.TD>
                                <Table.TD className="bid-time">
                                  {dateMonDayYearTimeFull(
                                    value.detail.bidding_time
                                  )}
                                </Table.TD>
                                <Table.TD className="view-more">
                                  <Button
                                    className="link"
                                    onClick={() => {
                                      this.toggleModal(
                                        'modals-history-of-supplier',
                                        index
                                      )
                                    }}
                                  >
                                    <Image src={ICONS['icon-view.svg']} />
                                  </Button>
                                </Table.TD>
                              </Table.TR>
                            ))
                          ) : (
                            <Table.TR>
                              <Table.TD>
                                <Section className="no-result-found">
                                  <p>Data not found</p>
                                </Section>
                              </Table.TD>
                            </Table.TR>
                          )}
                        </Table.TBODY>
                      </Table>
                    </Section>
                  </>
                ) : null}

                <Section className="form-actions" style={{ marginTop: '20px' }}>
                  <Section className="button-group"></Section>

                  <Section className="button-group">
                    {getAuctionItem.auction_status_id === 3 ||
                    getAuctionItem.auction_status_id === 4 ||
                    getAuctionItem.auction_status_id === 5 ||
                    getAuctionItem.is_cancel == true ? (
                      <Button
                        className="theme-border-gray"
                        onClick={() => {
                          this.props.history.push(
                            ROUTE_PATH.SOURCING_SUPPLIER.LINK
                          )
                        }}
                      >
                        Close
                      </Button>
                    ) : getAuctionItem.auction_status_id === 2 ? (
                      <React.Fragment>
                        <Button
                          className="theme-border-gray"
                          onClick={() => {
                            this.props.history.push(
                              ROUTE_PATH.SOURCING_SUPPLIER.LINK
                            )
                          }}
                        >
                          {dateWithin24 ? 'Close' : 'Cancel'}
                        </Button>
                        {dateWithin24 ? (
                          ''
                        ) : (getAuctionItem.auction_supplier_response_status ===
                            'Rejected' ||
                            getAuctionItem.auction_supplier_response_status ===
                              'Accepted') &&
                          isQuote === false ? null : (
                          <>
                            <Button
                              className="theme-blue btn-width-auto"
                              onClick={() => {
                                this.setState({
                                  clicks: 0,
                                })
                                this.onClickConfirmResponse(getAuctionItem)
                              }}
                            >
                              Accept Invitation
                            </Button>
                            <Button
                              className="theme-red btn-width-auto"
                              onClick={e => {
                                if (e.detail === 1) {
                                  this.onClickReject(
                                    suppliersEvent.code,
                                    suppliersEventData.name
                                    // props.values
                                  )
                                }
                              }}
                            >
                              Reject Invitation
                            </Button>
                          </>
                        )}
                        {dateWithin24 ? (
                          ''
                        ) : (getAuctionItem.auction_supplier_response_status ===
                            'Rejected' ||
                            getAuctionItem.auction_supplier_response_status ===
                              'Accepted') &&
                          isQuote === false ? (
                          <Button
                            className="theme-blue btn-width-auto"
                            onClick={() => {
                              this.onClickQuote(getAuctionItem)
                            }}
                          >
                            {/* Quote */}
                            {/* Change */}
                            Revise Invitation
                          </Button>
                        ) : null}
                      </React.Fragment>
                    ) : null}
                  </Section>
                </Section>
              </>
            )}
            {this.modalConfirmResponse(formData)}
          </Section>
        )
      }
      return (
        <Section className="main-content create-event">
          <Section className="content-body">{funcloadingContent()}</Section>
        </Section>
      )
    }
    const renderModalBuyerInformation = () => {
      const funcOnClickModalClose = e => {
        this.toggleModal()
        return document.body.classList.remove('modal-open')
      }
      return (
        <Modal
          id="buyer-info"
          className="buyer-info theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'buyer-info'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>Buyer Information</Modal.Header>
          <div className="style-table">
            <Modal.Body>
              <Section className="form-group-header">Buyer Profile</Section>
              <Section className="form-group">
                <label>Buyer Name</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      type="text"
                      disabled={true}
                      value={
                        getBuyerData
                          ? getBuyerData.company.company_name_eng
                          : null
                      }
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Tax ID</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      type="text"
                      disabled={true}
                      value={getBuyerData ? getBuyerData.company.tax_id : null}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>

              <Section className="form-row">
                <Section className="form-col col-6">
                  <Section className="form-group-header">
                    Registered Address
                  </Section>

                  <Section className="form-group">
                    <label>Address</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <InputTextarea
                          disabled={true}
                          value={
                            getBuyerData
                              ? getBuyerData.company.regis_address
                              : null
                          }
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>

                  <Section className="form-group">
                    <label>Country</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          disabled={true}
                          value={
                            getBuyerData
                              ? getBuyerData.company.regis_country
                              : null
                          }
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
                <Section className="form-col col-6">
                  <Section className="form-group-header">
                    Contact Address
                  </Section>

                  <Section className="form-group">
                    <label>Address</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <InputTextarea
                          disabled={true}
                          value={
                            getBuyerData
                              ? getBuyerData.company.contact_address
                              : null
                          }
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>

                  <Section className="form-group">
                    <label>Country</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          disabled={true}
                          value={
                            getBuyerData
                              ? getBuyerData.company.contact_country.name
                              : null
                          }
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Phone</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      type="text"
                      disabled={true}
                      value={getBuyerData ? getBuyerData.company.phone : '-'}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Fax (Optional)</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      type="text"
                      disabled={true}
                      value={getBuyerData ? getBuyerData.company.fax : '-'}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Email</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      type="text"
                      disabled={true}
                      value={getBuyerData ? getBuyerData.company.email : '-'}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Website (Optional)</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      type="text"
                      disabled={true}
                      value={getBuyerData ? getBuyerData.company.website : '-'}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Modal.Body>
          </div>
          <Modal.Footer>
            <Button
              id="close_modal_add-supplier"
              className="theme-border-gray close"
              onClick={funcOnClickModalClose}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalHistoryOfSupplier = () => {
      const handlersClose = () => {
        return this.toggleModal()
      }
      const { role } = store.getState()
      return (
        this.state.modals
          .filter(modal => {
            return modal.name === 'modals-history-of-supplier'
          })
          .map(obj => obj.isOpen)[0] && (
          <ModalHistoryOfSupplier
            modals={modals}
            // toggleModal={this.state.modals}
            itemBidHistory={[
              bidHistoryOfSupplier[
                this.state.modals
                  .filter(modal => {
                    return modal.name === 'modals-history-of-supplier'
                  })
                  .map(obj => obj.Idlist)[0]
              ],
            ]}
            eventData={suppliersEventData}
            role={role}
            bidHistoryId={
              this.state.modals
                .filter(modal => {
                  return modal.name === 'modals-history-of-supplier'
                })
                .map(obj => obj.Idlist)[0]
            }
            bidHistoryLength={bidHistoryOfSupplier.length}
            handlersClose={handlersClose}
          />
        )
      )
    }
    const renderModalRejectItem = () => {
      return (
        <Modal
          id="reject-item"
          className="theme-blue modal-reject-supplier"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'reject-item'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="768px"
        >
          {/* <Modal.Header>Reject Item</Modal.Header> */}
          {rejectItem ? (
            <React.Fragment>
              <Modal.Header>Reject Item</Modal.Header>
              <Modal.Body>
                <Section className="form-group">
                  <label>Item Name:</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper text">
                      {rejectItem.name}
                    </Section>
                  </Section>
                </Section>
                <Section className="form-group">
                  <label>Item Description:</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper text">
                      {rejectItem.description}
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>
                <Section className={`form-group ${isErrReason && 'is-error'}`}>
                  <label>Reason:</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <SelectBox
                        id="active_reason_filter"
                        options={reasonStatus}
                        value={reasonStatus.filter(
                          option =>
                            option.label ===
                            this.state.defaultSelectedRejItem.label
                        )}
                        defaultValue={this.state.defaultSelectedRejItem}
                        placeholder="Select"
                        isSearchable={false}
                        isClearable={false}
                        onChange={e => {
                          this.reasonStatus = e.label
                          this.setState({ defaultSelectedRejItem: { ...e } })
                          if (
                            this.reasonStatus !==
                            'Other, please specify - อื่น ๆ กรุณาระบุ'
                          ) {
                            rejectItem.reject_reason = e.label
                            this.setState({
                              rejectItem,
                            })
                          } else {
                            rejectItem.reject_reason = ''
                            this.setState({
                              reasonStatus,
                            })
                          }
                          this.setState({
                            isErrReason: false,
                            isErrOther: false,
                          })
                        }}
                      />
                    </Section>
                    <Section className="message">
                      {isErrReason && STRING.INVALID}
                    </Section>
                  </Section>
                </Section>
                <Section className={`form-group ${isErrOther && 'is-error'}`}>
                  <label></label>
                  <Section className="form-group-control">
                    {this.state.defaultSelectedRejItem.label ===
                    'Other, please specify - อื่น ๆ กรุณาระบุ' ? (
                      <Section className="form-group-inner-wrapper">
                        <InputTextarea
                          onChange={e => {
                            rejectItem.reject_reason = e.target.value
                            this.setState({
                              rejectItem,
                            })
                          }}
                        ></InputTextarea>
                      </Section>
                    ) : null}
                    <Section className="message">
                      {isErrOther && STRING.INVALID}
                    </Section>
                  </Section>
                </Section>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  id="close_modal_add-supplier"
                  className="theme-border-gray"
                  onClick={() => {
                    rejectItem.reject_reason = ''
                    this.reasonStatus = ''
                    this.setState({
                      isErrReason: false,
                      isErrOther: false,
                      rejectItem: '',
                    })
                    this.toggleModal('reject-item'),
                      document.body.classList.remove('modal-open')
                  }}
                >
                  Close
                </Button>
                <Button
                  className="theme-green"
                  onClick={() => {
                    const self = this
                    function clickRejItem() {
                      self._clickAcceptRejItem++
                    }
                    clickRejItem()
                    if (`${this.state.isRejectIndex}`) {
                      if (this.state.defaultSelectedRejItem.value == 5) {
                        getRFQItem.item_suppliers[
                          this.state.isRejectIndex
                        ].reject_reason = rejectItem.reject_reason
                      } else {
                        getRFQItem.item_suppliers[
                          this.state.isRejectIndex
                        ].reject_reason = this.state.defaultSelectedRejItem.label
                      }
                      getRFQItem.item_suppliers[
                        this.state.isRejectIndex
                      ].unit_price = ''
                      getRFQItem.item_suppliers[
                        this.state.isRejectIndex
                      ].event_supplier_item_files = []
                      this.setState({ getRFQItem })
                    }
                    if (this._clickAcceptRejItem === 0) {
                      this.onClickOkRejectItem(rejectItem, sumItemSuppliers)
                      this.rejectItem = ''
                    } else if (this._clickAcceptRejItem === 1) {
                      this.onClickOkRejectItem(rejectItem, sumItemSuppliers)
                      this.rejectItem = ''
                    }
                    // if (rejectItem.reject_reason != 'Select') {
                    //   this.toggleModal('reject-item'),
                    //     document.body.classList.remove('modal-open')
                    // }
                  }}
                >
                  Confirm
                </Button>
              </Modal.Footer>
            </React.Fragment>
          ) : null}
        </Modal>
      )
    }
    const renderModalTerms = () => {
      return (
        <Modal
          id="terms-conditions"
          className="terms-conditions theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'terms-conditions'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>Terms & Conditions</Modal.Header>

          <Modal.Body>
            <Section className="terms-conditions-body">
              {/* term_condition_detail */}
              <Section>
                {getBuyerData ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: getBuyerData.company.term_condition,
                    }}
                  />
                ) : (
                  <p></p>
                )}
              </Section>

              <Section className="form-group">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper checkbox">
                    <Checkbox
                      id="supplier_need_to_join"
                      value="want-to-join"
                      checked={agreeConditions}
                      onChange={e => this.onAgreeConditions(e)}
                    >
                      I agree to the terms and conditions
                    </Checkbox>
                  </Section>
                </Section>
              </Section>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_add-supplier"
              className="theme-border-gray close"
              onClick={() => {
                this.props.history.push(ROUTE_PATH.SOURCING_SUPPLIER.LINK)
              }}
            >
              Cancel
            </Button>
            {agreeConditions ? (
              <Button
                className="theme-green save"
                onClick={() => {
                  const self = this
                  function clickAccept() {
                    self._clickAccept++
                  }
                  clickAccept()
                  if (self._clickAccept === 1) {
                    if (this.state.eventType === 1) {
                      this.acceptAgreeConditions()
                    }
                    if (this.state.eventType === 2) {
                      this.acceptAgreeConditions()
                    }
                  }
                }}
              >
                Accept
              </Button>
            ) : (
              <Button className="theme-green save" disabled={true}>
                Accept
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalWarning = () => {
      return (
        <Modal
          id="warning"
          className="modal-warning theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'warning'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth={'800px'}
        >
          <Modal.Header>
            <strong>WARNING:</strong> Your response to auction invitation is
            REQUIRED!
          </Modal.Header>

          <Modal.Body>
            <p>
              By accepting &quot;Term &amp; Conditions&quot;, your online
              invitation&#39;s response status will not be automatically changed
              to &quot;Accepted&quot;
            </p>
            <p>
              Please select either &quot;Accept&quot; or &quot;Reject&quot; the
              invitation within 24 hours prior to the requested auction&#39;s
              starting time to do so.
            </p>
            <p>
              การตกลงยอมรับข้อกำหนดและเงื่อนไขข้อตกลงการเสนอราคา &quot;Terms
              &amp; Conditions&quot; <br />{' '}
              ไม่ถือเป็นการตอบรับเข้าร่วมการประมูลออนไลน์โดยอัตโนมัติ
            </p>
            <p>
              กรุณาเลือก &quot;ตอบรับ&quot; หรือ &quot;ปฏิเสธ&quot; ภายใน 24
              ชั่วโมงก่อนงานประมูลจะเริ่มต้น <br /> หากท่านไม่สามารถ
              &quot;ตอบรับ&quot; การเข้าร่วมงานประมูลภายในระยะเวลาที่กำหนดไว้
              จะไม่สามารถเข้าร่วมงานประมูลได้
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="theme-blue save"
              onClick={() => {
                this.toggleModal('warning'),
                  document.body.classList.remove('modal-open')
              }}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalConfirm = () => {
      const { priceRFQItemHistory } = this.state
      return (
        <Modal
          id="confirm"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'confirm'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Confirm</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to quote ? <br />
              {modals[0].FullName}
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="theme-border-gray"
              onClick={() => {
                this.toggleModal('confirm'),
                  document.body.classList.remove('modal-open')
              }}
            >
              Cancel
            </Button>

            <Button
              className="theme-green"
              onClick={() => {
                this.setState({
                  isQuote: true,
                })
                rejectItem.is_reject = false
                rejectItem.unit_price = '0'
                rejectItem.total_price = '0'
                rejectItem.reject_reason = ''
                rejectItem.note_to_buyer = ''
                rejectItem.event_supplier_item_files = []

                // if (priceRFQItemHistory.length > 0) {
                //   const isIndex = priceRFQItemHistory.findIndex(
                //     element => element.rfq_item_id === rejectItem.rfq_item_id
                //   )
                //   if (isIndex < 0) {
                //     priceRFQItemHistory.push(rejectItem)
                //   } else {
                //     priceRFQItemHistory[isIndex] = rejectItem
                //   }
                // } else {
                //   priceRFQItemHistory.push(rejectItem)
                // }
                // this.setState({ priceRFQItemHistory })
                this.toggleModal('confirm'),
                  document.body.classList.remove('modal-open')
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalConfirmQuote = () => {
      return (
        <Modal
          id="confirm-all"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'confirm-all'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Confirm</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to {eventType === 1 ? 'quote' : 'revise invitation '}
              ?
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="theme-border-gray"
              onClick={() => {
                this.toggleModal('confirm-all'),
                  document.body.classList.remove('modal-open')
              }}
            >
              Cancel
            </Button>

            <Button
              className="theme-green"
              onClick={() => {
                this.onClickConfirm(quoteData)
                this.toggleModal('confirm-all'),
                  document.body.classList.remove('modal-open')
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalRejectItemAll = () => {
      return (
        <Modal
          id="reject-all"
          className="theme-blue modal-reject-supplier"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'reject-all'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="768px"
        >
          <Modal.Header>
            {eventType === 1 ? 'Reject RFQ' : 'Auction Event Rejection'}
          </Modal.Header>
          <React.Fragment>
            <Modal.Body>
              <Section className="form-group">
                <label>Event No.:</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper text">
                    {suppliersEvent ? suppliersEvent.code : null}
                  </Section>
                </Section>
              </Section>
              <Section className="form-group">
                <label>Event Name:</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper text">
                    {suppliersEventData ? suppliersEventData.name : null}
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
              <Section className={`form-group ${isErrReasonAll && 'is-error'}`}>
                <label>Reason:</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <SelectBox
                      id="active_reason_filter"
                      options={reasonStatus}
                      value={reasonStatus.filter(
                        option =>
                          option.label ===
                          this.state.defaultSelectedRejAll.label
                      )}
                      defaultValue={this.state.defaultSelectedRejAll}
                      placeholder="Select"
                      isSearchable={false}
                      isClearable={false}
                      onChange={e => {
                        this.reasonStatus = e.label
                        this.setState({ defaultSelectedRejAll: { ...e } })
                        if (
                          this.reasonStatus !==
                          'Other, please specify - อื่น ๆ กรุณาระบุ'
                        ) {
                          if (eventType === 1) {
                            getRFQItem.reject_reason = e.label
                            this.setState({
                              getRFQItem,
                            })
                          }
                          if (eventType === 2) {
                            getAuctionItem.reject_reason = e.label
                            this.setState({
                              getAuctionItem,
                            })
                          }
                        } else {
                          getAuctionItem.reject_reason = ''
                          getRFQItem.reject_reason = ''
                          this.setState({
                            reasonStatus,
                          })
                        }
                        this.setState({
                          isErrReasonAll: false,
                          isErrOther: false,
                        })
                      }}
                    />
                  </Section>
                  <Section className="message">
                    {isErrReasonAll && STRING.INVALID}
                  </Section>
                </Section>
              </Section>
              <Section className={`form-group ${isErrOther && 'is-error'}`}>
                <label></label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    {this.state.defaultSelectedRejAll.label ===
                    'Other, please specify - อื่น ๆ กรุณาระบุ' ? (
                      <InputTextarea
                        value={
                          getRFQItem.reject_reason ||
                          getAuctionItem.reject_reason
                        }
                        onChange={e => {
                          getAuctionItem.reject_reason = e.target.value
                          getRFQItem.reject_reason = e.target.value
                          this.setState({
                            getRFQItem,
                            isErrOther: false,
                          })
                        }}
                      ></InputTextarea>
                    ) : null}
                  </Section>
                  <Section className="message">
                    {isErrOther && STRING.INVALID}
                  </Section>
                </Section>
              </Section>
            </Modal.Body>

            <Modal.Footer>
              <Button
                id="close_modal_add-supplier"
                className="theme-border-gray"
                onClick={() => {
                  this.reasonStatus = ''
                  this.setState({
                    reasonStatus,
                    isErrOther: false,
                    isErrReasonAll: false,
                  })
                  this.toggleModal('reject-all'),
                    document.body.classList.remove('modal-open')
                }}
              >
                Close
              </Button>
              <Button
                className="theme-green"
                onClick={() => {
                  const self = this
                  function clickRejAll() {
                    self._clickAcceptRejAll++
                  }
                  clickRejAll()
                  // RFQ
                  if (eventType === 1) {
                    if (`${this.state.isRejectIndex}`) {
                      if (this.state.defaultSelectedRejAll.value == 5) {
                        getRFQItem.item_suppliers[
                          this.state.isRejectIndex
                        ].reject_reason = getRFQItem.reject_reason
                      } else {
                        getRFQItem.item_suppliers[
                          this.state.isRejectIndex
                        ].reject_reason = this.state.defaultSelectedRejAll.label
                      }
                      this.setState({ getRFQItem })
                    }

                    if (this._clickAcceptRejAll === 0) {
                      this.onClickOkReject(getRFQItem)
                    } else if (this._clickAcceptRejAll === 1) {
                      this.onClickOkReject(getRFQItem)
                    }
                  }

                  // Auction
                  if (eventType === 2) {
                    if (`${this.state.isRejectIndex}`) {
                      if (this.state.defaultSelectedRejAll.value == 5) {
                        getAuctionItem.item_suppliers[
                          this.state.isRejectIndex
                        ].reject_reason = getAuctionItem.reject_reason
                      } else {
                        getAuctionItem.item_suppliers[
                          this.state.isRejectIndex
                        ].reject_reason = this.state.defaultSelectedRejAll.label
                      }
                      this.setState({ getAuctionItem })
                    }

                    if (this._clickAcceptRejAll === 0) {
                      this.onClickOkReject(getAuctionItem)
                    } else if (this._clickAcceptRejAll === 1) {
                      this.onClickOkReject(getAuctionItem)
                    }
                  }
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </React.Fragment>
        </Modal>
      )
    }

    const { isLoading } = this.state

    return (
      <React.Fragment>
        <SourcingDetailSupplierFormStyled>
          {funcRenderPageTitle()}
          {funcRenderPageContent()}
        </SourcingDetailSupplierFormStyled>
        {renderModalBuyerInformation()}
        {renderModalRejectItem()}
        {renderModalTerms()}
        {renderModalWarning()}
        {renderModalConfirm()}
        {renderModalConfirmQuote()}
        {renderModalRejectItemAll()}
        {renderModalHistoryOfSupplier()}
        <Loading loading={isLoading} spinner={isLoading} />
      </React.Fragment>
    )
  }
  render = () => this.renderSourcingDetailFormSupplier()
}
